<template>
    <!-- Loader -->
    <div id="div-with-loading" class="vs-con-loading__container promo-req-loading br-top">
        <h2 v-if="formData['verifyPromo']" class="verifyPromo-heading">
            Verify Promo
        </h2>

        <vx-card class="mb-base body-p0" :class="formData['verifyPromo'] ? 'verifyPromo-screen' : ''">
            <div class="client-details mb-0 border-b">
                <h4 class="mb-4 inline-flex section-title">Client Details</h4>
                <div class="vx-row m0">
                    <div class="flex w-auto">
                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Entity:</label>
                            <treeselect :disabled="!flags['enabledEntity']" name="client" class="w-full" v-model="client_id" :async="true" :load-options="clientSearchOptions" :multiple="false" :flat="true" :sort-value-by="sortValueBy" :default-expand-level="1" :clearable="true" v-validate="flags['enabledEntity'] ? 'required' : ''" data-vv-validate-on="change" placeholder="" @select="handleTreeselect($event)"/>
                            <span class="text-danger text-sm" v-show="errors.has('client')">Required field</span>
                        </div>
                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Group:</label>
                            <v-select :disabled="this.client_id !== null" name="group" class="w-full" v-model="formData['group_id']" :options="formGroups" :multiple="false" :closeOnSelect="true" v-validate="this.client_id == null ? 'required' : ''" data-vv-validate-on="change"></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('group')">Required field</span>
                        </div>
                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Currency:</label>
                            <v-select name="currencyType" class="w-full" v-model="formData['currency_type']" :options="formCurrencies" :clearable="false" :disabled="!flags['enabledInternal']"></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('currencyType')">Required field</span>
                        </div>
                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Payment Mode:</label>
                            <v-select name="paymentMode" class="w-full" v-model="formData['payment_mode']" :options="formInit['payment_modes']" v-validate="formData['internalRequired']" data-vv-validate-on="change" :clearable="false" :disabled="!flags['enabledInternal']"></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('paymentMode')">Required field</span>
                        </div>
                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">List Frequency:</label>
                            <v-select name="listFrequency" class="w-full" v-model="formData['list_frequency']" :options="formInit['list_frequencies']" v-validate="formData['internalRequired']" data-vv-validate-on="change" :clearable="false" :disabled="!flags['enabledInternal']"></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('listFrequency')">Required field</span>
                        </div>
                    </div>
                    
                    <div class="flex justify-between w-100 agt-name-wrap">
                        <div v-if="agtFileData.length" class="vx-col w-full mb-2 form-field agt-names">
                            <label class="vs-input--label inline-flex pb-2">Agreement:</label>
                            <div class="flex items-center">
                                <div v-for="(name, index) in agtFileData" :key="index" class="filename-wrap mr-2">
                                    <code class="existing-filename"><a :href="agtFileData[index].link" taget="_blank">{{ agtFileData[index].label }}</a>
                                        <vs-button color="danger" type="border" icon-pack="feather" icon="icon-x" class="remove-agt-file-btn" @click="removeAgtFile(agtFileData[index].value)"></vs-button>
                                    </code>
                                </div>
                            </div>
                        </div>
                        <div class=" vx-col w-full mb-2 form-field flex justify-end vs-select-agt-button items-center">
                            <vs-button @click="openAgreementList()" color="primary" type="border" :disabled="!client_id && !formData['group_id']">Select Agreement</vs-button>
                        </div>
                        <SelectAgreementComponent v-if="this.registrarforSuggestions" :registrar="registrarforSuggestions" :reseller="resellerForSuggestions" :selectedGeneralAgreements="selectedGeneralAgreements"></SelectAgreementComponent>
                    </div>
                </div>
            </div>

            <div v-if="this.groupClientName.length" class="group-clients">
                <h6 class="pb-1">{{ formData["group_id"].type }}:</h6>
                <code v-for="(name, index) in groupClientName" :key="`groupname-${index}`" class="promoname groupname inline-block mt-2 mr-2">{{ name }}</code>
            </div>

            <vs-collapse class="add-form-collapse">
                <!-- NOTE: CNIC Promos -->
                <vs-collapse-item :open="flags['allowCNIC']" :disabled="disableCNICFlag ||!flags['allowCNIC']" class="add-form-collapse-item">
                    <div slot="header">CNIC Promos</div>

                    <div class="form-actions">
                        <vs-button type="border" :class="enabledCNICText == 'Enabled' ? 'enabledBtn' : 'disabledBtn'" class="enableBtn" @click="cnicToggleBtn">{{ enabledCNICText }}</vs-button>
                        <span class="br-line mr-5 ml-5"></span>
                        <vx-tooltip text="Add new row" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-plus" @click="addCNICPromoFormRow"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Duplicate promo" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-copy" @click="duplicateCNICPromoFormRow" :disabled="cnicCounter.length !== 1"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Delete promo" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-trash-2" @click="deleteCNICPromoFormRow"></vs-button>
                        </vx-tooltip>
                    </div>

                    <div class="table-container">
                        <table class="add-cnic-promos-table">
                            <tr>
                                <th></th>
                                <th>TLD</th>
                                <th>Type</th>
                                <th>CNIC IDs</th>
                                <th>Premium</th>
                                <th>Effective 1Yr Price</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Start Time <span style="font-size: 9px" class="ml-1">{{ formData["disaplayTimezone"] }}</span></th>
                                <th>End Time<span style="font-size: 9px" class="ml-1">{{ formData["disaplayTimezone"] }}</span></th>
                                <th>Promo Name</th>
                            </tr>

                            <tr v-for="(cnic, counter) in cnicpromo" v-bind:key="counter">
                                <td>
                                    <vs-checkbox v-model="cnic.checkBox"> </vs-checkbox>
                                </td>
                                <td>
                                    <div>
                                        <div>
                                            <v-select ref="cnicTLDVSelect" class="w-full cnic-tld-dropdown" v-validate="formData['CNICRequired']" :name="`cnicTLD-${counter}`" data-vv-validate-on="change" v-model="cnic.tld_id" :disabled="!client_id && (!formData['group_id'] || !formData['group_id'].hasOwnProperty('label'))" append-to-body :options="formTlds" :clearable="false" :multiple="true" :closeOnSelect="false" @option:selected="clearSelectedCNICIDs(counter)" @option:deselected="clearSelectedCNICIDs(counter)"></v-select>
                                        </div>

                                        <span class="text-danger text-sm" v-show="errors.has(`cnicTLD-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select class="w-full" v-validate="formData['CNICRequired']" :name="`cnicType-${counter}`" data-vv-validate-on="change" v-model="cnic.type_of_reg" append-to-body :options="formInit['type_of_reg']" :clearable="false"></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`cnicType-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex">
                                        <vs-textarea disabled rows="1" class="w-full" v-validate="formData['CNICRequired'] && !flags['enabledEntity']" :name="`CNIC IDs-${counter}`" data-vv-validate-on="change" v-model="cnic.selectedCNICIDs" :key="`per-input-${counter}`" />
                                        
                                        <div class="sm:w-1/5 inline-flex">
                                            <vs-button @click="openSelectCNICIDsPopup(counter)" :disabled="!cnic.tld_id.length || !client_id || formData['group_id'].hasOwnProperty('label')" color="primary" :type="client_id == null ? 'border' : 'filled'" icon-pack="feather" :icon="cnic.selectedCNICIDs == '' ? 'icon-plus' : 'icon-edit'" style="margin-left: 5px; padding: 0 !important"></vs-button>
                                        </div>
                                        <span class="text-danger text-sm" v-show="errors.has(`CNIC IDs-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select class="w-full" v-validate="formData['CNICRequired']" name="`cnicPremium-${counter}`" data-vv-validate-on="change" v-model="cnic.premium" :options="formInit['premium']" :clearable="false" append-to-body></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`cnicPremium-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div v-if="cnic.premium.value !== 1" class="w-full inputPrefix">
                                            <vs-input class="w-full" v-validate="
                                            flags['enabledCNIC'] && !disableCNICFlag
                                            ? 'required|min_value:0.01'
                                            : ''" 
                                            :name="`Effective Promo Price-${counter}`" data-vv-validate-on="change" v-model="cnic.effective_price_amt" :key="`amt-input-${counter}`" />
                                            <span class="currency-sign">$</span>
                                            <span class="text-danger text-sm currency-error" v-if="errors.has('Effective Promo Price-' + counter)">
                                                Required field
                                            </span>
                                        </div>
                                        <div v-else class="w-full inputPrefix">
                                            <vs-input class="w-full" v-validate="'required|min_value:0.01'" :name="`Percentage Discount-${counter}`" data-vv-validate-on="change" v-model="cnic.effective_price_per" :key="`per-input-${counter}`" />
                                            <span class="currency-sign">%</span>
                                            <span class="text-danger text-sm currency-error" v-show="errors.has('Percentage Discount-' + counter)">Required field</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <flat-pickr class="w-full" v-validate="formData['CNICRequired']" :name="`cnic Start date-${counter}`" data-vv-validate-on="change" :config="cnic.configFromdateTimePicker" v-model="cnic.start_date" placeholder="YYYY-MM-DD" @on-change="onFromChangeCNIC($event, counter)" />
                                        <span class="text-danger text-sm" v-show="errors.has('cnic Start date-' + counter)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div class="flex">
                                            <flat-pickr class="w-full" v-validate="formData['CNICRequired']" :name="`cnic End date-${counter}`" data-vv-validate-on="change" :config="cnic.configTodateTimePicker" v-model="cnic.end_date" placeholder="YYYY-MM-DD" @on-change="onToChangeCNIC($event, counter)" />
                                            <span class="text-danger text-sm" v-show="errors.has('cnic End date-' + counter)">Required field</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <flat-pickr class="w-full" :config="configdateTimePicker" v-model="cnic.start_time" placeholder="00:00:00" />
                                        <span class="text-danger text-sm" v-show="errors.has('startTime')">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <flat-pickr class="w-full" :config="configdateEndTimePicker" v-model="cnic.end_time" placeholder="23:59:59" />
                                        <span class="text-danger text-sm" v-show="errors.has('endTime')">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <vs-input class="w-full promoname" v-validate="formData['CNICRequired']" name="Promo name" data-vv-validate-on="change" v-model="cnic.promo_name" disabled="disabled" />
                                        <span class="text-danger text-sm" v-show="errors.has('Promo name')">Required field</span>
                                    </div>
                                </td>
                            </tr>
                        </table>

                        <CNICPromoSuggestions :client="registrarforSuggestions" :tld="cnicTld" v-if="!formData['verifyPromo'] && flags['enabledCNIC']"></CNICPromoSuggestions>
                    </div>
                </vs-collapse-item>

                <!-- NOTE: Internal Promos -->
                <vs-collapse-item :open="flags['allowInternalPromo']" :disabled="!flags['allowInternalPromo']" class="add-form-collapse-item">
                    <div slot="header">Internal Promos</div>

                    <div class="form-actions">
                        <vs-button type="border" :class="enabledInternalText == 'Enabled' ? 'enabledBtn' : 'disabledBtn'" class="enableBtn pointer-events-auto" @click="internalToggleBtn" :disabled="registrar_id && !reseller_id">{{ enabledInternalText }}</vs-button>
                        <vx-tooltip text="Add agreement" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-file-plus" @click="openAgreementList('internal')" :disabled="!client_id || promoCounter.length == 0"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Add comment" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-message-square" @click="addComments" :disabled="promoCounter.length == 0"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Add new row" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-plus" @click="addPromoFormRow"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Duplicate promo" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-copy" @click="duplicatePromoFormRow" :disabled="promoCounter.length !== 1"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Delete promo" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-trash-2" @click="deletePromoFormRow"></vs-button>
                        </vx-tooltip>
                    </div>

                    <div class="table-container">
                        <table class="add-internal-promos-table">
                            <tr>
                                <th></th>
                                <th>TLD</th>
                                <th>Type</th>
                                <th>Period (Yrs)</th>
                                <th>List Based</th>
                                <th>Retail Price</th>
                                <th>Effective 1Yr Price
                                    <vx-tooltip text="Add the cost for 1-Yr of registration" position="top" class="flex ml-1">
                                        <feather-icon icon="AlertCircleIcon" :svgClasses="`h-4 w-4`" />
                                    </vx-tooltip>
                                </th>
                                <th>Effective Multi-Yr Price
                                    <vx-tooltip text="Add the cost of years 2-10" position="top" class="flex ml-1">
                                        <feather-icon icon="AlertCircleIcon" :svgClasses="`h-4 w-4`" />
                                    </vx-tooltip>
                                </th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Promo Tag</th>
                                <th>Agreement</th>
                                <th>Custom Tag</th>
                                <th>Geo</th>
                            </tr>

                            <tr v-for="(promo, counter) in promos" v-bind:key="counter">
                                <td class="checkbox">
                                    <vs-checkbox v-model="promo.checkBox"> </vs-checkbox>
                                </td>
                                <td>
                                    <div class="flex">
                                        <vx-tooltip v-model="promo.comments" :text="`${promo.comments}`" position="top" class="w-1/6" append-to-body :class="!promo.comments ? 'pointer-events-none' : ''">
                                            <vs-button v-if="promo.comments !== ''" color="dark" type="flat" icon-pack="feather" icon="icon-message-square"></vs-button>
                                        </vx-tooltip>
                                        <v-select :name="`tld-${counter}`" class="w-5/6" v-model="promo.tld_id" :options="formTlds" v-validate="formData['internalRequired']" data-vv-validate-on="change" :multiple="true" :closeOnSelect="false" :clearable="false" append-to-body>
                                        </v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`tld-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select :name="`type-${counter}`" class="w-full" v-model="promo.type" :options="formInit['types']" v-validate="formData['internalRequired']" data-vv-validate-on="change" @input="handlePeriod($event)" :clearable="false" append-to-body></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`type-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select :name="`period-${counter}`" class="w-full" v-model="promo.period" :options="formInit['periods']" v-validate="formData['internalRequired']" data-vv-validate-on="change" @input="handlePeriod($event)" :multiple="true" :closeOnSelect="false" :clearable="false" append-to-body
                                        :selectable=" promo.selectableOption !== '' &&
                                            promo.selectableOption === 'All'
                                            ? (option) => option === '1'
                                            : promo.selectableOption === ''
                                            ? (option) => true
                                            : (option) => option !== '1'">
                                            </v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`period-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select :name="`list-based-${counter}`" class="w-full" v-model="promo.list_based" :options="formInit['list_based']" v-validate="formData['internalRequired']" data-vv-validate-on="change" :clearable="false" append-to-body></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`type-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div class="flex">
                                            <v-select name="currencyType" class="w-3/4 retail-currency" v-model="promo.retail_currency" :options="formCurrencies" :clearable="false" append-to-body></v-select>
                                            <vs-input :name="`retail price-${counter}`" class="w-3/5 retail-currency-value" v-validate="
                                            promo.type.includes('premium')
                                            ? ''
                                            : formData['internalRequired']" 
                                            data-vv-validate-on="change" v-model="promo.retail_price" :disabled="promo.type.includes('premium')" />
                                        </div>
                                        <span class="text-danger text-sm" v-if="errors.has(`retail price-${counter}`)">
                                            Required field
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div v-if="promo.type.includes('premium')" class="inputPrefix">
                                            <vs-input :name="`year price per-${counter}`" class="w-full" 
                                            v-validate="promo.disabledYearPrice ? '' : formData['internalRequired']" 
                                            data-vv-validate-on="change" v-model="promo.year_price_per" icon-pack="feather" icon="icon-percent" icon-no-border :key="`per-input-${counter}`" :disabled="promo.disabledYearPrice" />
                                            <span class="text-danger text-sm currency-error" v-show="errors.has(`year price per-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                        <div v-else class="inputPrefix">
                                            <vs-input :name="`year price-${counter}`" class="w-full" 
                                                v-validate="promo.disabledYearPrice ? '' : formData['internalRequired']" 
                                                data-vv-validate-on="change" v-model="promo.year_price" :key="`amt-input-${counter}`" :disabled="
                                                promo.disabledYearPrice" />
                                            <span class="currency-sign">{{ promo.currencySign }}</span>
                                            <span class="text-danger text-sm currency-error" v-show="errors.has(`year price-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div v-if="promo.type.includes('premium')" class="inputPrefix">
                                            <vs-input :name="`multi year price per-${counter}`" class="w-full" v-validate="promo.disabledMultiYearPrice || promo.type.includes('renew') ? '' : formData['internalRequired']" data-vv-validate-on="change" v-model="promo.multi_year_price_per" icon-pack="feather" icon="icon-percent" icon-no-border :key="`multi-year-per-input-${counter}`" :disabled="promo.type.includes('renew') || promo.disabledMultiYearPrice" />
                                            <span class="text-danger text-sm currency-error" v-show="errors.has(`multi year price per-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                        <div v-else class="inputPrefix">
                                            <vs-input :name="`multi year price-${counter}`" class="w-full" v-validate="promo.disabledMultiYearPrice || promo.type.includes('renew') ? '' : formData['internalRequired']" data-vv-validate-on="change" v-model="promo.multi_year_price" :key="`multi-year-input-${counter}`" :disabled="promo.type.includes('renew') || promo.disabledMultiYearPrice" />
                                            <span class="currency-sign">{{ promo.currencySign }}</span>
                                            <span class="text-danger text-sm currency-error" v-show="errors.has(`multi year price-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <flat-pickr :name="`start date-${counter}`" v-model="promo.start_date" placeholder="YYYY-MM-DD" class="w-full" v-validate="formData['internalRequired']" data-vv-validate-on="change" :config="promo.configFromdateTimePicker" @on-change="onFromChange($event, counter)" />
                                        <span class="text-danger text-sm" v-show="errors.has(`start date-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <flat-pickr :name="`end date-${counter}`" v-model="promo.end_date" placeholder="YYYY-MM-DD" class="w-full" v-validate="formData['internalRequired']" data-vv-validate-on="change" :config="promo.configTodateTimePicker" @on-change="onToChange($event, counter)" />
                                        <span class="text-danger text-sm" v-show="errors.has(`end date-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select :name="`promo tag-${counter}`" class="w-full" v-validate="formData['internalRequired']" v-model="promo.promo_tag" :options="formPromoTags" data-vv-validate-on="change" :clearable="false" append-to-body></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`promo tag-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div v-for="(name, index) in promo.internalAgtFileData" :key="index" class="filename-wrap internalFilename-wrap">
                                            <code class="existing-filename"><a :href="promo.internalAgtFileData[index].link" taget="_blank">{{ promo.internalAgtFileData[index].label }}</a>
                                                <vs-button color="danger" type="border" icon-pack="feather" icon="icon-x" class="remove-agt-file-btn" @click="
                                                removeInternalAgtFile(promo.internalAgtFileData[index].value, counter)">
                                                </vs-button>
                                            </code>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex">
                                        <v-select :name="`custom tag-${counter}`" class="sm:w-4/5" v-model="promo.custom_tag" :options="formCustomTags" v-validate="formData['internalRequired']" data-vv-validate-on="change" :clearable="false" append-to-body></v-select>
                                        <div class="sm:w-1/5 inline-flex">
                                            <vs-button @click="openAddTagModal(counter)" color="dark" type="border" icon-pack="feather" icon="icon-plus" style="padding: 0 !important"></vs-button>
                                        </div>
                                        <span class="text-danger text-sm" v-show="errors.has(`custom tag-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <v-select :name="`geo-${counter}`" class="w-full" v-model="promo.geo" :options="formGeo" data-vv-validate-on="change" :clearable="false" append-to-body></v-select>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <!-- Internal suggestions -->
                        <InternalPromoSuggestions :client="resellerForSuggestions" :tld="promoTld" v-if="!formData['verifyPromo'] && flags['enabledInternal']"></InternalPromoSuggestions>
                    </div>
                </vs-collapse-item>

                <!-- NOTE: MIS -->
                <vs-collapse-item :open="flags['allowMIS']" :disabled="!flags['allowMIS']" class="add-form-collapse-item">
                    <div slot="header">MIS</div>
                    <div class="form-actions">
                        <vs-button type="border" :class="enabledMISText == 'Enabled' ? 'enabledBtn' : 'disabledBtn'" class="enableBtn pointer-events-auto" @click="misToggleBtn" :disabled="registrar_id && !reseller_id">{{ enabledMISText }}</vs-button>
                        <vx-tooltip text="Add new row" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-plus" @click="addMISFormRow"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Duplicate MIS" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-copy" @click="duplicateMISFormRow" :disabled="misCounter.length !== 1"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Delete MIS" position="top">
                            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-trash-2" @click="deleteMISFormRow"></vs-button>
                        </vx-tooltip>
                    </div>

                    <div class="table-container">
                        <table class="add-mis-table">
                            <tr>
                                <th></th>
                                <th>TLD</th>
                                <th>Type</th>
                                <th>Period (Yrs)</th>
                                <th>Effective 1Yr Price</th>
                                <th>Effective Multi-Yr Price</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                            </tr>

                            <tr v-for="(misItem, counter) in mis" v-bind:key="counter">
                                <td>
                                    <vs-checkbox v-model="misItem.checkBox"> </vs-checkbox>
                                </td>
                                <td>
                                    <div class="table-form-component">
                                        <v-select :name="`mis tld-${counter}`" class="w-full" v-model="misItem.tld_id" :options="formTlds" v-validate="formData['misRequired']" data-vv-validate-on="change" :multiple="true" :closeOnSelect="false" :clearable="false" append-to-body></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`mis tld-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-form-component">
                                        <v-select :name="`mis type-${counter}`" class="w-full" v-model="misItem.type" :options="formInit['types']" v-validate="formData['misRequired']" data-vv-validate-on="change" :clearable="false" append-to-body></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`mis type-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-form-component">
                                        <v-select :name="`mis period-${counter}`" class="w-full" v-model="misItem.period" :options="formInit['periods']" v-validate="formData['misRequired']" data-vv-validate-on="change" :multiple="true" :closeOnSelect="false" :clearable="false" append-to-body @input="handleMISPeriod($event)" :selectable="
                                            misItem.selectableOption !== '' &&
                                            misItem.selectableOption === 'All'
                                            ? (option) => option === '1'
                                            : misItem.selectableOption === ''
                                            ? (option) => true
                                            : (option) => option !== '1'"></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has(`mis period-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="inputPrefix">
                                        <div v-if="misItem.type.includes('premium')" class="inputPrefix">
                                            <vs-input placeholder="" :name="`mis year price per-${counter}`" class="w-full" v-validate="misItem.disabledYearPrice ? '' : 'required'" 
                                            data-vv-validate-on="change" v-model="misItem.year_price_per" :key="`permis-input-${counter}`" :disabled="misItem.disabledYearPrice" />
                                            <span class="currency-sign">%</span>
                                            <span class="text-danger text-sm mis-currency-error" v-show="errors.has(`mis year price per-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                        <div v-else class="inputPrefix">
                                            <vs-input placeholder="" :name="`mis year price-${counter}`" class="w-full" v-validate="flags['enabledMIS'] && !misItem.disabledYearPrice ? 'required' : ''" 
                                            data-vv-validate-on="change" v-model="misItem.year_price" :key="`amtmis-input-${counter}`" :disabled="misItem.disabledYearPrice" />
                                            <span class="currency-sign">$</span>
                                            <span class="text-danger text-sm mis-currency-error" v-show="errors.has(`mis year price-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-form-component">
                                        <div v-if="misItem.type.includes('premium')" class="inputPrefix">
                                            <vs-input placeholder="" :name="`mis multi year price per-${counter}`" class="w-full" v-validate="flags['enabledMIS'] && !misItem.period.includes('1') ? 'required' : ''"
                                            data-vv-validate-on="change" v-model="misItem.multi_year_price_per" :key="`permis-multi-input-${counter}`"/>
                                            <span class="currency-sign">%</span>
                                            <span class="text-danger text-sm mis-currency-error" v-show="errors.has(`mis multi year price per-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                        <div v-else class="inputPrefix">
                                            <vs-input placeholder="" :name="`mis multi year price-${counter}`" class="w-full" v-validate="flags['enabledMIS'] ? 'required' : ''" data-vv-validate-on="change" v-model="misItem.multi_year_price" :key="`amtmis-multi-input-${counter}`"/>
                                            <span class="currency-sign">$</span>
                                            <span class="text-danger text-sm mis-currency-error" v-show="errors.has(`mis multi year price-${counter}`)">
                                                Required field
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-form-component">
                                        <div class="relative">
                                            <flat-pickr :name="`mis start date-${counter}`" v-model="misItem.start_date" placeholder="YYYY-MM-DD" class="w-full" v-validate="formData['misRequired']" data-vv-validate-on="change" :config="misItem.configFromdateTimePicker" @on-change="onFromChangeMIS($event, counter)" />
                                        </div>
                                        <span class="text-danger text-sm" v-show="errors.has(`mis start date-${counter}`)">Required field</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-form-component">
                                        <div class="relative">
                                            <flat-pickr :name="`mis end date-${counter}`" v-model="misItem.end_date" placeholder="YYYY-MM-DD" class="w-full" v-validate="formData['misRequired']" data-vv-validate-on="change" :config="misItem.configTodateTimePicker" @on-change="onToChangeMIS($event, counter)" />
                                        </div>
                                        <span class="text-danger text-sm" v-show="errors.has(`mis end date-${counter}`)">Required field</span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <!-- MIS suggestions -->
                        <MISSuggestions :client="resellerForSuggestions" :tld="misTld" v-if="!formData['verifyPromo'] && flags['enabledMIS']"></MISSuggestions>
                    </div>
                </vs-collapse-item>
            </vs-collapse>
            
            <div class="common-comments flex">
                <div class="w-4/5">
                    <label class="mb-2 inline-block">Comments:</label>
                    <vs-textarea placeholder="Write your comment here..." class="w-11/12" v-model="formData['common_comments']" />
                </div>
                <div class="w-1/5 text-right verify-btn">
                    <div v-if="!formData['verifyPromo']">
                        <vs-button color="primary" type="filled" class="action-btn" @click="verifyPromo()">Verify & Submit Promo</vs-button>
                        <div>
                            <span class="text-danger text-sm" v-show="formData['agtsError']">{{ formData["agtsError"] }}</span>
                        </div>
                    </div>
                    <div v-else>
                        <vs-button color="dark" type="border" class="dark-btn mr-4" @click="verifyPromo()">Edit Promo</vs-button>
                        <vs-button color="primary" type="filled" class="action-btn" @click="onSubmit()">Submit Promo</vs-button>
                    </div>
                </div>
            </div>
        </vx-card>

        <!-- Custom Tag Popup -->
        <vs-popup class="customTag-popup" title="Add Custom Tag" :active.sync="popupCustomTag">
            <div id="div-with-modal-loading" class="div-with-agreement-modal-loading vs-con-loading__container">
                <div class="vx-row flex-wrap">
                    <div class="vx-col w-full mb-6 flex flex-wrap">
                        <div class="w-6/12 pl-2 pr-2">
                            <label class="vs-input--label inline-flex pb-2">Tag Name:</label>
                            <vs-input class="w-full" v-model="formData['CustomeTagName']" />
                            <span v-show="formData['existingTagName']" class="text-danger text-sm">{{ formData["existingTagName"] }}</span>
                        </div>
                        <div class="w-6/12 pl-2 pr-2">
                            <label class="vs-input--label inline-flex pb-2">Comments:</label>
                            <vs-textarea class="w-full" v-model="formData['CustomeTagComments']" />
                        </div>
                    </div>
                </div>
                <vs-button id="button-with-loading" color="primary" type="filled" class="action-btn flex mr-auto ml-auto mb-4" @click="onAddCustomTag()" :disabled="formData['CustomeTagName'] == '' || formData['CustomeTagComments'] == ''">Save</vs-button>
            </div>
        </vs-popup>

        <!-- Comments Popup -->
        <vs-popup class="comments-popup" title="Add Comment for Selected Internal Promo" :active.sync="addCommentPopup">
            <div id="div-with-modal-loading" class="div-with-agreement-modal-loading vs-con-loading__container">
                <div class="vx-row flex-wrap">
                    <vs-table class="action-dash-table" :data="selectedPromoForActions">
                        <template slot="thead">
                            <vs-th class="pointer-events-none">Period</vs-th>
                            <vs-th class="pointer-events-none">Type</vs-th>
                            <vs-th class="pointer-events-none">TLD</vs-th>
                            <vs-th class="pointer-events-none">Start Date</vs-th>
                            <vs-th class="pointer-events-none">End Date</vs-th>
                            <vs-th class="pointer-events-none">Retail Price</vs-th>
                            <vs-th class="pointer-events-none">Effective 1Yr Price</vs-th>
                            <vs-th class="pointer-events-none">Effective Multi-Yr Price</vs-th>
                            <vs-th class="pointer-events-none">Promo Tag</vs-th>
                            <vs-th class="pointer-events-none">Agreement</vs-th>
                            <vs-th class="pointer-events-none">Geo</vs-th>
                            <vs-th class="pointer-events-none">Custom Tag</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    <div class="inline-block w-24 md:w-auto">
                                        {{ data[indextr].period.toString() }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="inline-block w-24 md:w-auto">
                                        {{ data[indextr].type }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="inline-block w-24 md:w-auto">
                                        {{ data[indextr].tld_id.map((x) => x.name).toString() }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="inline-block w-24 md:w-auto">
                                        {{ data[indextr].start_date }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center">{{ data[indextr].end_date }}</div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center">
                                        {{ data[indextr].retail_currency.sign }}
                                        {{ data[indextr].retail_price }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center" v-if="data[indextr].type.includes('premium')">
                                        % {{ data[indextr].multi_year_price_per }}
                                    </div>
                                    <div class="items-center" v-else>
                                        {{ data[indextr].currencySign }}
                                        {{ data[indextr].multi_year_price }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center" v-if="data[indextr].type.includes('premium')">
                                        % {{ data[indextr].year_price_per }}
                                    </div>
                                    <div class="items-center" v-else>
                                        {{ data[indextr].currencySign }}
                                        {{ data[indextr].year_price }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center">
                                        {{ data[indextr].promo_tag.label }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center">
                                        <div v-for="(name, number) in data[indextr].internalAgtFileData" :key="number" class="filename-wrap internalFilename-wrap">
                                            <code class="existing-filename">
                                                <a :href="data[indextr].internalAgtFileData[number].link" taget="_blank">
                                                    {{ data[indextr].internalAgtFileData[number].label }}
                                                </a>
                                            </code>
                                        </div>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center">
                                        {{ data[indextr].custom_tag.label }}
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="items-center">{{ data[indextr].geo.label }}</div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <div class="vx-col w-full mb-6 comment-wrap">
                        <label class="mb-2 inline-block">AM's Comments: </label>
                        <vs-textarea placeholder="Write your comment here..." class="w-full" v-model="formData['CommentsText']" />
                    </div>
                </div>
                <vs-button color="primary" type="filled" class="flex ml-auto mb-4 mr-4 action-btn" @click="saveComments" :disabled="formData['CommentsText'] == ''">Save</vs-button>
            </div>
        </vs-popup>

        <!-- Select CNIC Ids Popup -->
        <vs-popup class="select-cnicIDs-popup" title="Select CNIC IDs" :active.sync="popupSelectCNICIDs">
            <div id="selectCNICIDs-with-loading" class="div-with-modal-loading vs-con-loading__container">
                <div class="">
                    <div class="static-box-header">
                        <div class="header">CNIC ID List</div>
                        <!-- <div class="form-actions">
                            <vx-tooltip text="Select All" position="top">
                                <span class="selectAllCNICIDs-pointer" @click="selectAllCNICIDs()"><u>Select All</u></span>
                            </vx-tooltip>
                        </div> -->
                    </div>

                    <div>
                        <div class="cnic-id-container flex flex-wrap">
                            <div v-for="selectCNICID in cnicpromo[cnicPromoCounterForCNICID].tempSelectCNICIDs['registrars']" :key="`selectCNICID-${selectCNICID['cnic_id']}`" class="cnic-id-select-item flex">
                                <vs-checkbox class="select-cnic-id-checkbox vs-checkbox-small" v-model="selectCNICID.checkBox"></vs-checkbox>
                                <span class="select-cnic-id-value">{{ selectCNICID['cnic_id'] }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="vx-row flex mb-10 justify-end">
                    <div class="vx-col w-1/4 save-btn mt-12">
                        <vs-button id="button-with-loading" color="primary" type="filled" class="custom-btn ml-auto" @click="validateCNICIDTLDCombination()" icon-after>Save</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

        <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
            <div class="con-content" slot="content">
                <p>The IDs submitted are not available. Check the data and try again. Please check the following entry(s):</p>

                <ul>
                    <li v-for="error in customPromptError" :key="`error-${error}`">
                        {{ error.cnic_id }} - CNIC ID not associated with <strong>{{ error.tld.join(", ") }}</strong>
                    </li>
                </ul>
            </div>
        </custom-prompt>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import SelectAgreementComponent from "@/components/ag-grid-tables/promos/SelectAgreementComponent.vue";
import CNICPromoSuggestions from "@/components/ag-grid-tables/promos/CNICPromoSuggestions.vue";
import InternalPromoSuggestions from "@/components/ag-grid-tables/promos/InternalPromoSuggestions.vue";
import MISSuggestions from "@/components/ag-grid-tables/promos/MISSuggestions.vue";
import Treeselect from "@riophae/vue-treeselect";

// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
    name: 'AddCNICPromo',
    components: {
        "v-select": vSelect,
        flatPickr,
        SelectAgreementComponent,
        CNICPromoSuggestions,
        InternalPromoSuggestions,
        MISSuggestions,
        Treeselect,
        CustomPrompt,
    },
    data() {
        return {
            promoNameSpan: [],
            client_id: null,
            reseller_id: null,
            registrar_id: null,
            registrar_name: null,
            sortValueBy: "ORDER_SELECTED",
            enabledCNICText: "Enabled",
            enabledInternalText: "Enabled",
            enabledMISText: "Enabled",
            configdateTimePicker: {
                time_24hr: true,
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i:S",
                enableSeconds: true,
                defaultDate: "00:00:00",
                allowInput: true,
            },
            configdateEndTimePicker: {
                time_24hr: true,
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i:S",
                enableSeconds: true,
                defaultDate: "23:59:59",
                allowInput: true,
            },
            CnicTldValue: [],
            LocalTldValue: [],
            MisTldValue: [],
            registrarforSuggestions: [],
            resellerForSuggestions: [],
            groupClientName: [],
            agtFileData: [],
            cnicpromo: [
                {
                    checkBox: false,
                    promo_name: "",
                    tld_id: [],
                    effective_price_amt: "",
                    effective_price_per: "",
                    price_type: [{ label: "$", value: "$" }],
                    premium: { label: "No", value: 0 },
                    type_of_reg: "",
                    start_date: null,
                    end_date: null,
                    start_time: "00:00:00",
                    end_time: "23:59:59",
                    configFromdateTimePicker: {
                        minDate: new Date(),
                        maxDate: null,
                    },
                    configTodateTimePicker: {
                        minDate: null,
                    },
                    selectedCNICIDs: "",
                    selectCNICIDs: {},
                    tempSelectCNICIDs: {},
                },
            ],
            promos: [
                {
                    checkBox: false,
                    type: [],
                    list_based: "Yes",
                    tld_id: [],
                    period: [],
                    start_date: null,
                    end_date: null,
                    retail_price: "",
                    retail_currency: {
                        label: "USD  -  $",
                        value: 12,
                        sign: "$",
                    },
                    currencySign: "$",
                    year_price: "",
                    year_price_per: "",
                    multi_year_price: "",
                    multi_year_price_per: "",
                    promo_tag: [],
                    internalAgtFileData: [],
                    selectableOption: "",
                    custom_tag: [],
                    geo: {
                        label: "NA",
                        value: null,
                    },
                    comments: "",
                    disabledYearPrice: false,
                    disabledMultiYearPrice: false,
                    uploadedLocalFile: "",
                    configFromdateTimePicker: {
                        minDate: new Date(this.$moment().subtract(9, 'months')),
                        maxDate: null,
                        wrap: true,
                    },
                    configTodateTimePicker: {
                        minDate: null,
                        wrap: true,
                    },
                },
            ],
            mis: [
                {
                    checkBox: false,
                    tld_id: [],
                    type: [],
                    period: [],
                    start_date: null,
                    end_date: null,
                    year_price: "",
                    multi_year_price: "",
                    year_price_per: "",
                    multi_year_price_per: "",
                    MISEnableText: "Enabled",
                    disableMIS: true,
                    selectableOption: "",
                    disabledYearPrice: false,
                    // disabledMultiYearPrice: false,
                    configFromdateTimePicker: {
                        minDate: new Date(this.$moment().subtract(9, 'months')),
                        maxDate: null,
                        wrap: true,
                        //maxDate: new Date().fp_incr(2),
                    },
                    configTodateTimePicker: {
                        minDate: null,
                        wrap: true,
                    },
                },
            ],
            addCommentPopup: false,
            selectedPromoForActions: [],
            cnicCounter: [],
            promoCounter: [],
            misCounter: [],
            disableDuplicateMis: true,
            disableDuplicatepromo: true,
            tempData: [],
            formData: {
                selectedPromoName: {
                    selectedGroup: "",
                    selectedTLD: "",
                    selectedClient: "",
                    selectedType: "",
                    selectedPrem: "",
                    selectedMonthYear: "",
                    selectedClientId: "",
                    selectedCountryId: "",
                },
                promo_name: "",
                promo_name_new: "",
                reseller_id: [],
                payment_mode: "",
                group_id: [],
                currency_type: { label: "USD  -  $", value: 12 },
                list_frequency: "",
                list_based: "Yes",
                localpromo: [],
                status: "approval pending",
                CustomeTagName: "",
                CustomeTagComments: "",
                TagNameData: "",
                existingTagName: "",
                CommentsText: "",
                common_comments: "",
                verifyPromo: false,
                disaplayTimezone: "(UTC)",
                CNICRequired: "required",
                internalRequired: "required",
                misRequired: "required",
                CNICData: true,
                internalData: true,
                MISData: true,
                agtsError: "",
            },
            formInit: {
                reseller_ids: [],
                group_ids: [],
                payment_modes: ["CNIC", "Bank Transfer"],
                list_frequencies: ["Monthly", "Quarterly"],
                agreements: [],
                types: ["new", "renew", "premium new", "premium renew"],
                list_based: ["Yes", "No"],
                periods: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
                tld_ids: [],
                promo_tags: [],
                custom_tags: [],
                geos: [],
                currencies: [],
                type_of_reg: ["Registration", "Renewal"],
                premium: [
                    {
                        label: "Yes",
                        value: 1,
                    },
                    {
                        label: "No",
                        value: 0,
                    },
                ],
            },
            PromoNamePartRecommendation: [],
            getMinYearPrice: [],
            getMinMultiYearPrice: [],
            popupActive: false,
            popupActivePromo: false,
            popupCustomTag: false,
            popupSelectCNICIDs: false,
            tempCustomTag: "",
            configFromdateTimePicker: {
                // minDate: new Date(),
                maxDate: null,
                wrap: true,
            },
            configTodateTimePicker: {
                minDate: null,
                wrap: true,
            },
            flags: {
                showCNICRelated: false,
                isFormSubmitted: false,
                enabledCNIC: true,
                enabledInternal: true,
                enabledMIS: true,
                enabledEntity: true,
                allowCNIC: true,
                allowInternalPromo: true,
                allowMIS: true,
                internalAgmt: false,
            },
            selectedGeneralAgreements: [],
            showTLDDropdown: false,
            // Custom Dialog props
            customPrompt: {
                activePrompt: false,
                title: "",
                buttonText: "",
                type: "",
                color: "",
                classList: "",
            },
            customPromptError: null,
            cnicPromoCounterForCNICID: 0
        };
    },
    watch: {
        // "formData.currency_type"(e) {
        //     this.promos.forEach((x) => {
        //         x.currencySign = e.sign;
        //         x.retail_currency = {
        //             label: e.label,
        //             value: e.value,
        //             sign: e.sign,
        //         };
        //     });
        // },

        "formData.CustomeTagName"(val) {
            this.customTagCheck();
        },

        "formData.group_id"(val, oldVal) {
            this.groupClientName = [];
            if (
                val &&
                val.hasOwnProperty("label") &&
                JSON.stringify(val) != JSON.stringify(oldVal)
            ) {
                this.formData["selectedPromoName"]["selectedGroup"] = val.label
                    .split(" ")
                    .join("-");

                this.registrar_id = null;
                this.reseller_id = null;
                if (val.type == "registrar") {
                    this.groupClientName = val.new_registrar_group.map(
                        (x) => x.new_registrar.unique_registrar.name + " - " + x.new_registrar.cnic_id
                    );
                    // Disable Internal & MIS & Enable CNIC
                    this.disableOrEnableInternalAndMis(false);
                    this.disableOrEnableCNIC(true);
                    // Disable Entity
                    this.flags["enabledEntity"] = false;
                    this.client_id = null;
                    // Set Registrars for suggestions
                    this.resellerForSuggestions = [];
                    this.registrarforSuggestions = val.new_registrar_group.map(x => { return { value: x.new_registrar.id, label: x.new_registrar.unique_registrar.name, cnic_id: x.new_registrar.cnic_id, unique_registrar_id: x.new_registrar.unique_registrar.id }})
                } else if (val.type == "reseller") {
                    this.groupClientName = val.new_reseller_group.map(
                        (x) => x.new_reseller.name
                    );
                    this.disableOrEnableCNIC(false);
                    this.disableOrEnableInternalAndMis(true);
                    this.flags["enabledEntity"] = false;
                    this.client_id = null;
                    // Set Resellers for suggestions
                    this.registrarforSuggestions = [];
                    this.resellerForSuggestions = val.new_reseller_group.map(x =>{
                        return {
                            label: x.new_reseller.name,
                            value: x.new_reseller.id
                        }
                    })
                } else {
                    this.flags["enabledEntity"] = true;
                    this.disableOrEnableCNIC(true);
                    this.disableOrEnableInternalAndMis(true);
                }
            } else {
                this.flags["enabledEntity"] = true;
                this.resetGroup();
            }

            this.promoNameFormations();
        },

        agtFileData(val) {
            this.autoWidthForAgtNames();
            this.filterLocalPromoAgreements(val);
        },

        cnicpromo: {
            deep: true,
            handler() {
                this.tldForCNICSuggestions();
                this.getCNICRowIndex();
                this.promoNameFormations();
                this.CNICRelatedData();
            },
        },

        promos: {
            deep: true,
            handler() {
                this.tldForInternalSuggestions();
                this.handlePeriod();
                this.handleMISPeriod();
                this.getPromoRowIndex();
            },
        },

        mis: {
            deep: true,
            handler() {
                this.getRowIndex();
                this.handleMISPeriod();
                this.tldForMISSuggestions();
            },
        },

        client_id(val) {
            if (val) {
                if (val && val !== "") {
                    val = val.split("-");
                } else {
                    this.disableOrEnableCNIC(true);
                    this.formData["CNICRequired"] = "required";
                    this.country_id = null;
                    this.registrar_id = null;
                    this.reseller_id = null;
                }
                if (val && val.length) {
                    if (val[0] === "CNIC") {
                        this.registrar_id = val[1];
                        this.country_id = val[2];
                        this.registrar_name = val[3];
                        this.disableOrEnableCNIC(true);
                        this.disableOrEnableInternalAndMis(false);
                        this.flags["allowInternalPromo"] = false;
                        this.flags["allowMIS"] = false;
                        this.reseller_id = null;
                        this.formData["selectedPromoName"]["selectedClient"] =
                        this.registrar_name.split(" ").join("-");
                        this.resellerForSuggestions = [];
                    } else if (val[0] === "PROMO") {
                        this.reseller_id = val[1];
                        this.registrar_id = null;
                        this.disableOrEnableInternalAndMis(true);
                        this.flags["allowInternalPromo"] = true;
                        this.flags["allowMIS"] = true;
                        if (val[3] && val[3] === "SAME") {
                            this.flags["allowCNIC"] = true;
                            this.disableOrEnableCNIC(true);
                            this.registrar_id = val[2];
                            this.country_id = val[4];
                            this.resellerForSuggestions = [
                                {
                                    label: val[5],
                                    value: parseInt(val[1]),
                                },
                            ];
                            this.formData["selectedPromoName"][
                                "selectedClient"
                            ] = val[5].split(" ").join("-");
                        } else {
                            this.disableOrEnableCNIC(false);
                            this.flags["allowCNIC"] = false;
                            this.formData["CNICRequired"] = "";
                            this.resellerForSuggestions = [
                                {
                                    label: val[3],
                                    value: parseInt(val[1]),
                                },
                            ];
                            this.registrarforSuggestions = [];
                            this.formData["selectedPromoName"][
                                "selectedClient"
                            ] = val[3].split(" ").join("-");
                        }
                    }
                }

                //TimeZone changed for China client
                if (this.country_id && this.country_id == "38") {
                    this.cnicpromo.forEach((x) => {
                        x["start_time"] = "16:00:00";
                        x["end_time"] = "15:59:59";
                    });
                    this.formData["disaplayTimezone"] = "(UTC+08:00)";
                } else {
                    this.cnicpromo.forEach((x) => {
                        x["start_time"] = "00:00:00";
                        x["end_time"] = "23:59:59";
                    });
                    this.formData["disaplayTimezone"] = "(UTC)";
                }
            } else {
                this.client_id = null;
                this.registrar_id = null;
                this.reseller_id = null;
                this.registrar_name = null;
                this.registrarforSuggestions = [];
                this.resellerForSuggestions = [];
                this.disableOrEnableCNIC(true);
                this.disableOrEnableInternalAndMis(true);
                this.flags["allowCNIC"] = true;
                this.flags["allowInternalPromo"] = true;
                this.flags["allowMIS"] = true;
                this.formData["disaplayTimezone"] = "(UTC)";
                this.cnicpromo.forEach((x) => {
                    x["start_time"] = "00:00:00";
                    x["end_time"] = "23:59:59";
                    x["promo_name"] = "";
                    x["selectedCNICIDs"] = "";
                    x["tempSelectCNICIDs"] = {};
                    x["selectCNICIDs"] = {};
                });
                this.agtFileData = [];
                this.formData["selectedPromoName"]["selectedClient"] = "";
                this.cnicpromo.forEach((x) => {
                });
            }

            this.promoNameFormations();
        },

        // NOTE: Vuex master data getters(helpers)
        // TODO: Remove after testing (START)
        clientOptions() {
            // return this.$store.getters.setClientOptions;
            return this.$store.getters.getClientOptions;
        },
        // TODO: Remove after testing (END)
        formGroups() {
            return this.$store.getters.formGroups;
        },
        formCurrencies() {
            return this.$store.getters.formCurrencies;
        },
        formGeo() {
            return this.$store.getters.formGeo;
        },
        formTlds() {
            return this.$store.getters.formTlds;
        },
        formCNICTlds() {
            return this.$store.getters.formTlds.map((x) => {
                return {
                    id: x.value,
                    label: x.label,
                };
            });
        },
        formPromoTags() {
            return this.$store.getters.formPromoTags;
        },
        formCustomTags() {
            return this.$store.getters.formCustomTags;
        },
        disableCNICFlag() {
			return this.$store.getters.getDisableCNICFlag;
		}
    },
    computed: {
        user_details() {
            return JSON.parse(localStorage.getItem('userDetails'))
        },
        user_id() {
            return JSON.parse(localStorage.getItem("userDetails")).id;
        },

        user_role() {
            return JSON.parse(localStorage.getItem("userDetails")).role;
        },

        // NOTE: Vuex master data getters(helpers)
        // TODO: Remove after testing (START)
        clientOptions() {
            // return this.$store.getters.setClientOptions;
            return this.$store.getters.getClientOptions;
        },
        // TODO: Remove after testing (END)
        formGroups() {
            return this.$store.getters.formGroups;
        },
        formCurrencies() {
            return this.$store.getters.formCurrencies;
        },
        formGeo() {
            return this.$store.getters.formGeo;
        },
        formTlds() {
            return this.$store.getters.formTlds;
        },
        formCNICTlds() {
            return this.$store.getters.formTlds.map((x) => {
                return {
                    id: x.value,
                    label: x.label,
                };
            });
        },
        formPromoTags() {
            return this.$store.getters.formPromoTags;
        },
        formCustomTags() {
            return this.$store.getters.formCustomTags;
        },
        cnicTld: function () {
            return this.CnicTldValue;
        },
        promoTld: function () {
            return this.LocalTldValue;
        },
        misTld: function () {
            return this.MisTldValue;
        },
        disableCNICFlag() {
            return this.$store.getters.getDisableCNICFlag;
		}
    },
    methods: {
        handleTreeselect(event) {
            this.registrarforSuggestions = event.new_registrar;
        },
        clearSelectedCNICIDs(index) {
            this.cnicpromo[index]["selectedCNICIDs"] = "";
            this.cnicpromo[index]["selectCNICIDs"] = {};
            this.cnicpromo[index]["tempSelectCNICIDs"] = {};
        },
        clientSearchOptions({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                this.$axiosSecure.get(`/v2/unique-registrars/${searchQuery}`)
                .then(response => {
                    let clientsList = response.data;

                    var transformedClientsList = [];

                    for (var client of clientsList) {
                        var temp = {
                            id:
                                "CNIC-" +
                                client["id"] +
                                "-" +
                                client["country_id"] +
                                "-" +
                                client["name"],
                            label: client["name"],
                            isDisabled: this.user_details.role == "channel_user" ? ((client["unique_registrar_client_am"] && client["unique_registrar_client_am"].length && client["unique_registrar_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(client["unique_registrar_client_am"][0]["user_id"]) == -1) : false,
                            children: client["new_reseller"].length ? [] : undefined,
				            new_registrar: client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }})
                        };

                        if (client["new_reseller"].length) {
                            // Push resellers into obj
                            for (var reseller of client["new_reseller"]) {
                                temp["children"].push({
                                    id:
                                        reseller["name"] === client["name"]
                                            ? "PROMO-" +
                                            reseller["id"] +
                                            "-" +
                                            client["id"] +
                                            "-" +
                                            "SAME-" +
                                            client["country_id"] +
                                            "-" +
                                            reseller["name"]
                                            : "PROMO-" +
                                            reseller["id"] +
                                            "-" +
                                            client["id"] +
                                            "-" +
                                            reseller["name"],
                                    label: reseller["name"],
                                    isDisabled: this.user_details.role == "channel_user" ? ((reseller["new_reseller_client_am"] && reseller["new_reseller_client_am"].length && reseller["new_reseller_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(reseller["new_reseller_client_am"][0]["user_id"]) == -1) : false,
				                    new_registrar: reseller["name"] === client["name"] ? client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }}) : []
                                });
                            }
                        }

                        transformedClientsList.push(temp);
                    }

                    callback(null, transformedClientsList);
                })
                .catch(error => {
                    console.log("Entity Search Error", error);
                })
            }
        },
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },

        hideLoadingInDiv() {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },

        onFromChange(event, counter) {
            this.$set(
                this.promos[counter].configTodateTimePicker,
                "minDate",
                event[0]
            );
        },

        onToChange(event, counter) {
            this.$set(
                this.promos[counter].configFromdateTimePicker,
                "maxDate",
                event[0]
            );
        },

        onFromChangeCNIC(event, counter) {
            this.$set(
                this.cnicpromo[counter].configTodateTimePicker,
                "minDate",
                event[0]
            );
        },

        onToChangeCNIC(event, counter) {
            this.$set(
                this.cnicpromo[counter].configFromdateTimePicker,
                "maxDate",
                event[0]
            );
        },

        onFromChangeMIS(event, counter) {
            this.$set(
                this.mis[counter].configTodateTimePicker,
                "minDate",
                event[0]
            );
        },

        onToChangeMIS(event, counter) {
            this.$set(
                this.mis[counter].configFromdateTimePicker,
                "maxDate",
                event[0]
            );
        },

        toggleMISSection(counter) {
            this.mis[counter]["disableMIS"] = !this.mis[counter]["disableMIS"];
            if (this.mis[counter]["disableMIS"] == true) {
                this.mis[counter].MISEnableText = "Enabled";
                this.MISData = true;
                // this.$validator.reset();
            } else {
                this.mis[counter].MISEnableText = "Disabled";
                this.mis.splice(1);
                this.MISData = false;
            }
        },

        cnicToggleBtn() {
            this.flags["enabledCNIC"] = !this.flags["enabledCNIC"];
            this.flags["allowCNIC"] = !this.flags["allowCNIC"];
            if (this.flags["enabledCNIC"] == true) {
                this.enabledCNICText = "Enabled";
                this.formData["CNICData"] = true;
                this.formData["CNICRequired"] = "required";
            } else {
                this.enabledCNICText = "Disabled";
                this.formData["CNICRequired"] = "";
                this.formData["CNICData"] = false;
            }
        },

        internalToggleBtn() {
            this.flags["enabledInternal"] = !this.flags["enabledInternal"];
            this.flags["allowInternalPromo"] = !this.flags["allowInternalPromo"];
            if (this.flags["enabledInternal"] == true) {
                this.enabledInternalText = "Enabled";
                this.formData["internalRequired"] = "required";
                this.formData["internalData"] = true;
            } else {
                this.enabledInternalText = "Disabled";
                this.formData["internalRequired"] = "";
                this.formData["internalData"] = false;
            }
        },

        misToggleBtn() {
            this.flags["enabledMIS"] = !this.flags["enabledMIS"];
            this.flags["allowMIS"] = !this.flags["allowMIS"];
            if (this.flags["enabledMIS"] == true) {
                this.enabledMISText = "Enabled";
                this.formData["misRequired"] = "required";
                this.formData["MISData"] = true;
            } else {
                this.enabledMISText = "Disabled";
                this.formData["misRequired"] = "";
                this.formData["MISData"] = false;
            }
        },

        addPromoFormRow() {
            this.promos.push({
                checkBox: false,
                type: [],
                list_based: "Yes",
                tld_id: [],
                period: [],
                retail_price: "",
                retail_currency: { label: "USD  -  $", value: 12, sign: "$" },
                year_price: "",
                year_price_per: "",
                multi_year_price: "",
                multi_year_price_per: "",
                promo_tag: [],
                currencySign: "$",
                internalAgtFileData: [],
                custom_tag: {
                    label: "NA",
                    value: null,
                },
                geo: {
                    label: "NA",
                    value: null,
                },
                comments: "",
                disabledYearPrice: false,
                disabledMultiYearPrice: false,
                selectableOption: "",
                uploadedLocalFile: "",
                configFromdateTimePicker: {
                    minDate: new Date(this.$moment().subtract(9, 'months')),
                    maxDate: null,
                    wrap: true,
                },
                configTodateTimePicker: {
                    minDate: null,
                    wrap: true,
                },
            });
        },

        duplicatePromoFormRow() {
            var counter = this.promoCounter;
            //To get Data from single row
            var getDuplicatePromoTag = {
                label: this.promos[counter].promo_tag.label,
                value: this.promos[counter].promo_tag.value,
            };
            var getDuplicateTld = this.promos[counter].tld_id.map((x) => {
                return {
                    label: x.label,
                    name: x.name,
                    value: x.value,
                };
            });
            var getDuplicateCustomTag = {
                label: this.promos[counter].custom_tag.label,
                value: this.promos[counter].custom_tag.value,
            };
            var getDuplicateGeo = {
                label: this.promos[counter].geo.label,
                value: this.promos[counter].geo.value,
            };

            var getDuplicateAgtFile = this.promos[
                counter
            ].internalAgtFileData.map((x) => {
                return {
                    label: x.label,
                    link: x.link,
                    value: x.value,
                };
            });

            this.promos.push({
                checkBox: false,
                type: this.promos[counter].type,
                list_based: this.promos[counter].list_based,
                tld_id: getDuplicateTld,
                period: this.promos[counter].period,
                retail_price: this.promos[counter].retail_price,
                retail_currency: this.promos[counter].retail_currency,
                year_price: this.promos[counter].year_price,
                year_price_per: this.promos[counter].year_price_per,
                multi_year_price: this.promos[counter].multi_year_price,
                multi_year_price_per: this.promos[counter].multi_year_price_per,
                promo_tag: getDuplicatePromoTag,
                custom_tag: getDuplicateCustomTag,
                internalAgtFileData: getDuplicateAgtFile,
                geo: getDuplicateGeo,
                start_date: this.promos[counter].start_date,
                end_date: this.promos[counter].end_date,
                comments: this.promos[counter].comments,
                disabledYearPrice: this.promos[counter].disabledYearPrice,
                disabledMultiYearPrice: this.promos[counter].disabledMultiYearPrice,
                currencySign: this.promos[counter].currencySign,
                uploadedLocalFile: "",
                selectableOption: "",
                configFromdateTimePicker: {
                    minDate: new Date(this.$moment().subtract(9, 'months')),
                    maxDate: null,
                    wrap: true,
                },
                configTodateTimePicker: {
                    minDate: null,
                    wrap: true,
                },
            });
        },

        deletePromoFormRow() {
            var rowIndex = this.promoCounter;
            this.promos = this.promos.filter(
                (el, index) => !rowIndex.includes(index)
            );
            if (this.promos.length == 0) {
                this.addPromoFormRow();
            }
        },

        addCNICPromoFormRow() {
            this.cnicpromo.push({
                checkBox: false,
                tld_id: [],
                effective_price_amt: "",
                effective_price_per: "",
                premium: { label: "No", value: 0 },
                type_of_reg: "",
                start_date: null,
                end_date: null,
                start_time: "00:00:00",
                end_time: "23:59:59",
                timezone_start: "UTC",
                timezone_end: "UTC",
                promo_name: "",
                configFromdateTimePicker: {
                    minDate: new Date(),
                    maxDate: null,
                },
                configTodateTimePicker: {
                    minDate: null,
                },
                selectCNICIDs: {},
                tempSelectCNICIDs: {},
                selectedCNICIDs: ""
            });
        },

        duplicateCNICPromoFormRow() {
            var counter = this.cnicCounter;
            this.cnicpromo.push({
                checkBox: false,
                tld_id: [],
                effective_price_amt:
                    this.cnicpromo[counter].effective_price_amt,
                effective_price_per:
                    this.cnicpromo[counter].effective_price_per,
                premium: this.cnicpromo[counter].premium,
                type_of_reg: this.cnicpromo[counter].type_of_reg,
                start_date: this.cnicpromo[counter].start_date,
                end_date: this.cnicpromo[counter].end_date,
                start_time: this.cnicpromo[counter].start_time,
                end_time: this.cnicpromo[counter].end_time,
                timezone_start: this.cnicpromo[counter].timezone_start,
                timezone_end: this.cnicpromo[counter].timezone_end,
                configFromdateTimePicker: {
                    minDate: new Date().setHours(0,0,0,0),
                    maxDate: null,
                },
                configTodateTimePicker: {
                    minDate: null,
                },
                selectCNICIDs: {},
                tempSelectCNICIDs: {},
                selectedCNICIDs: ""
            });
        },

        getCNICRowIndex() {
            this.cnicCounter = [];
            this.cnicpromo.forEach((element, index) => {
                if (element.checkBox == true) {
                    var count = index;
                    this.cnicCounter.push(count);
                }
            });

            if (this.cnicCounter.length > 1) {
                this.disableDuplicateMis = true;
            } else {
                this.disableDuplicateMis = false;
            }
        },
        deleteCNICPromoFormRow() {
            var rowIndex = this.cnicCounter;
            this.cnicpromo = this.cnicpromo.filter(
                (el, index) => !rowIndex.includes(index)
            );

            this.cnicPromoCounterForCNICID = 0;
            
            if (this.cnicpromo.length == 0) {
                this.addCNICPromoFormRow();
            }
        },

        removeAgtFile(e) {
            var agtCounter = [e];
            this.agtFileData = this.agtFileData.filter(
                (x) => !agtCounter.includes(x["value"])
            );
        },

        removeInternalAgtFile(e, i) {
            var internalAgtCounter = [e];
            this.promos[i].internalAgtFileData = this.promos[
                i
            ].internalAgtFileData.filter(
                (x) => !internalAgtCounter.includes(x["value"])
            );
        },

        getPromoRowIndex() {
            this.promoCounter = [];
            this.promos.forEach((element, index) => {
                if (element.checkBox == true) {
                    var count = index;
                    this.promoCounter.push(count);
                }
            });

            if (this.promoCounter.length > 1) {
                this.disableDuplicatepromo = true;
            } else {
                this.disableDuplicatepromo = false;
            }
        },

        openAgreementList(e) {
            if (e == "internal") {
                this.flags.internalAgmt = true;
            } else {
                this.flags.internalAgmt = false;
            }
            this.$root.$emit("openSelectAgtList");
        },

        getRowIndex() {
            this.misCounter = [];
            this.mis.forEach((element, index) => {
                if (element.checkBox == true) {
                    var count = index;
                    this.misCounter.push(count);
                }
            });

            if (this.misCounter.length > 1) {
                this.disableDuplicateMis = true;
            } else {
                this.disableDuplicateMis = false;
            }
        },

        addComments() {
            this.addCommentPopup = true;
            this.selectedPromoForActions = this.promos.filter((el, index) =>
                this.promoCounter.includes(index)
            );
            if (!this.selectedPromoForActions.some((e) => e.comments !== "")) {
                this.formData["CommentsText"] = "";
            } else {
            }
        },
        saveComments() {
            for (var i = 0; i < this.promoCounter.length; i++) {
                var promoCounterValue = this.promoCounter[i];
                this.promos[promoCounterValue].comments =
                    this.formData["CommentsText"];
            }
            setTimeout(() => {
                this.addCommentPopup = false;
            }, 200);
        },

        addMISFormRow() {
            this.mis.push({
                checkBox: false,
                tld_id: [],
                type: [],
                period: [],
                start_date: null,
                end_date: null,
                year_price: "",
                multi_year_price: "",
                year_price_per: "",
                multi_year_price_per: "",
                MISEnableText: "Enabled",
                disableMIS: true,
                selectableOption: "",
                disabledYearPrice: false,
                // disabledMultiYearPrice: false,
                configFromdateTimePicker: {
                    minDate: new Date(this.$moment().subtract(9, 'months')),
                    maxDate: null,
                    wrap: true,
                },
                configTodateTimePicker: {
                    minDate: null,
                    wrap: true,
                },
            });
        },

        duplicateMISFormRow() {
            var rowIndex = this.misCounter;

            this.mis.push({
                checkBox: false,
                tld_id: [],
                type: this.mis[rowIndex].type,
                period: this.mis[rowIndex].period,
                start_date: this.mis[rowIndex].start_date,
                end_date: this.mis[rowIndex].end_date,
                year_price: this.mis[rowIndex].year_price,
                multi_year_price: this.mis[rowIndex].multi_year_price,
                year_price_per: this.mis[rowIndex].year_price_per,
                multi_year_price_per: this.mis[rowIndex].multi_year_price_per,
                MISEnableText: "Enabled",
                disableMIS: true,
                selectableOption: "",
                disabledYearPrice: this.mis[rowIndex].disabledYearPrice,
                // disabledMultiYearPrice: this.mis[rowIndex].disabledMultiYearPrice,
                configFromdateTimePicker: {
                    minDate: new Date(this.$moment().subtract(9, 'months')),
                    maxDate: null,
                    wrap: true,
                },
                configTodateTimePicker: {
                    minDate: null,
                    wrap: true,
                },
            });
        },

        deleteMISFormRow() {
            var rowIndex = this.misCounter;
            this.mis = this.mis.filter(
                (el, index) => !rowIndex.includes(index)
            );
            if (this.mis.length == 0) {
                this.addMISFormRow();
            }
        },

        formatCopiedCnicData(selectedRow) {
            var getDuplicateTld, getDuplicatePremium;

            getDuplicateTld = selectedRow.map((x) => {
                return {
                    label: x.tld.tld_name,
                    name: x.tld.tld_name,
                    value: x.tld_id,
                };
            });

            if (selectedRow.map((x) => x.premium) === "No") {
                getDuplicatePremium = {
                    label: "No",
                    value: "0",
                };
            } else {
                getDuplicatePremium = {
                    label: "Yes",
                    value: "1",
                };
            }

            if (
                this.cnicpromo[this.cnicpromo.length - 1].tld_id == "" ||
                this.cnicpromo[this.cnicpromo.length - 1].type_of_reg == "" ||
                this.cnicpromo[this.cnicpromo.length - 1].effective_price_amt == "" ||
                this.cnicpromo[this.cnicpromo.length - 1].effective_price_per == "" ||
                this.cnicpromo[this.cnicpromo.length - 1].premium == ""
            ) {
                this.cnicpromo[this.cnicpromo.length - 1].tld_id = getDuplicateTld;
                this.cnicpromo[this.cnicpromo.length - 1].effective_price_amt = selectedRow.map((x) => x.effective_price_amt).toString();
                this.cnicpromo[this.cnicpromo.length - 1].effective_price_per = selectedRow.map((x) => x.effective_price_per).toString();
                this.cnicpromo[this.cnicpromo.length - 1].premium = getDuplicatePremium;
                this.cnicpromo[this.cnicpromo.length - 1].type_of_reg = selectedRow.map((x) => x.type_of_reg).toString();
                this.cnicpromo[this.cnicpromo.length - 1].start_date = null;
                this.cnicpromo[this.cnicpromo.length - 1].end_date = null;
                this.cnicpromo[this.cnicpromo.length - 1].start_time = selectedRow.map((x) => x.effective_price_per).toString();
                this.cnicpromo[this.cnicpromo.length - 1].end_time = selectedRow.map((x) => x.end_time).toString();
                this.cnicpromo[this.cnicpromo.length - 1].promo_name =
                    selectedRow.map((x) => x.promo_name).toString();
            } else {
                this.cnicpromo.push({
                    checkBox: false,
                    tld_id: getDuplicateTld,
                    effective_price_amt: selectedRow
                        .map((x) => x.effective_price_amt)
                        .toString(),
                    effective_price_per: selectedRow
                        .map((x) => x.effective_price_per)
                        .toString(),
                    premium: getDuplicatePremium,
                    type_of_reg: selectedRow
                        .map((x) => x.type_of_reg)
                        .toString(),
                    start_date: null,
                    end_date: null,
                    start_time: selectedRow
                        .map((x) => x.effective_price_per)
                        .toString(),
                    end_time: selectedRow.map((x) => x.end_time).toString(),
                    promo_name: selectedRow.map((x) => x.promo_name).toString(),
                    configFromdateTimePicker: {
                        minDate: new Date(),
                        maxDate: null,
                    },
                    configTodateTimePicker: {
                        minDate: null,
                    },
                });
            }
        },

        formatCopiedPromo(selectedRow) {
            var getDuplicateTld,
                agmtMapData,
                getDuplicateAgtFile,
                getDuplicatePromoTag,
                getDuplicateCustomTag,
                getDuplicateGeo,
                getDuplicateRetailCurrency;

            getDuplicateTld = selectedRow.map((x) => {
                return {
                    label: x.tld.tld_name,
                    name: x.tld.tld_name,
                    value: x.tld_id,
                };
            });

            var customIdCheck = selectedRow.map((x) => x.custom_tag_id);
            if (customIdCheck[0] !== null) {
                getDuplicateCustomTag = selectedRow.map((x) => {
                    return {
                        label: x.customtag.tag_name,
                        value: x.customtag.id,
                    };
                });
            } else {
                getDuplicateCustomTag = {
                    label: "NA",
                    value: null,
                };
            }

            getDuplicatePromoTag = selectedRow.map((x) => {
                return {
                    label: x.promotag.tag_name,
                    value: x.promotag.id,
                };
            });

            var geoIdCheck = selectedRow.map((x) => x.geo_id);
            if (geoIdCheck[0] !== null) {
                getDuplicateGeo = selectedRow.map((x) => {
                    return {
                        label: x.geo.name,
                        value: x.geo.id,
                    };
                });
            } else {
                getDuplicateGeo = {
                    label: "NA",
                    value: null,
                };
            }

            agmtMapData = selectedRow.map((x) => x.agreements);
            getDuplicateAgtFile = agmtMapData[0].map((x) => {
                return {
                    label: x.filename,
                    value: x.id,
                    link: x.dropbox_link,
                };
            });

            getDuplicateRetailCurrency = selectedRow.map((x) => {
                if (x.retail) {
                    return {
                        label: x.retail.name + " - " + x.retail.sign,
                        value: x.retail.id,
                        sign: x.retail.sign,
                    };
                }
            });

            if (
                this.promos[this.promos.length - 1].tld_id == "" ||
                this.promos[this.promos.length - 1].type == "" ||
                this.promos[this.promos.length - 1].period == ""
            ) {
                (this.promos[this.promos.length - 1].tld_id = getDuplicateTld),
                    (this.promos[this.promos.length - 1].type = selectedRow.map((x) => x.type).toString()),
                    (this.promos[this.promos.length - 1].period = selectedRow.map((x) => x.period).toString()),
                    (this.promos[this.promos.length - 1].start_date = null),
                    (this.promos[this.promos.length - 1].end_date = null),
                    (this.promos[this.promos.length - 1].currencySign = selectedRow.map((x) => x.currency.sign).toString()),
                    (this.promos[this.promos.length - 1].retail_price = selectedRow.map((x) => x.retail_price).toString()),
                    (this.promos[this.promos.length - 1].retail_currency = getDuplicateRetailCurrency),
                    (this.promos[this.promos.length - 1].year_price = selectedRow.map((x) => x.effective_first).toString()),
                    (this.promos[this.promos.length - 1].multi_year_price = selectedRow.map((x) => x.effective_multi).toString()),
                    (this.promos[this.promos.length - 1].year_price_per = selectedRow.map((x) => x.effective_first_per).toString()),
                    (this.promos[this.promos.length - 1].multi_year_price_per = selectedRow.map((x) => x.effective_multi_per).toString()),
                    (this.promos[this.promos.length - 1].promo_tag = getDuplicatePromoTag),
                    (this.promos[this.promos.length - 1].custom_tag = getDuplicateCustomTag),
                    (this.promos[this.promos.length - 1].internalAgtFileData = getDuplicateAgtFile),
                    (this.promos[this.promos.length - 1].geo = getDuplicateGeo);
            } else {
                this.promos.push({
                    checkBox: false,
                    comments: "",
                    tld_id: getDuplicateTld,
                    type: selectedRow.map((x) => x.type).toString(),
                    period: selectedRow.map((x) => x.period).toString(),
                    start_date: null,
                    end_date: null,
                    currencySign: selectedRow.map((x) => x.currency.sign).toString(),
                    retail_price: selectedRow.map((x) => x.retail_price).toString(),
                    retail_currency: getDuplicateRetailCurrency,
                    year_price: selectedRow.map((x) => x.effective_first).toString(),
                    multi_year_price: selectedRow.map((x) => x.effective_multi).toString(),
                    year_price_per: selectedRow.map((x) => x.effective_first_per).toString(),
                    multi_year_price_per: selectedRow.map((x) => x.effective_multi_per).toString(),
                    promo_tag: getDuplicatePromoTag,
                    custom_tag: getDuplicateCustomTag,
                    internalAgtFileData: getDuplicateAgtFile,
                    geo: getDuplicateGeo,
                    configFromdateTimePicker: {
                        minDate: new Date(this.$moment().subtract(9, 'months')),
                        maxDate: null,
                        wrap: true,
                    },
                    configTodateTimePicker: {
                        minDate: null,
                        wrap: true,
                    },
                });
            }
        },

        formatCopiedMIS(selectedRow) {
            var getDuplicateTld;

            getDuplicateTld = selectedRow.map((x) => {
                return {
                    label: x.tld.tld_name,
                    name: x.tld.tld_name,
                    value: x.tld_id,
                };
            });

            if (
                this.mis[this.mis.length - 1].tld_id == "" ||
                this.mis[this.mis.length - 1].type == "" ||
                this.mis[this.mis.length - 1].period == ""
            ) {
                this.mis[this.mis.length - 1].tld_id = getDuplicateTld;
                this.mis[this.mis.length - 1].type = selectedRow.map((x) => x.type).toString();
                this.mis[this.mis.length - 1].period = selectedRow.map((x) => x.period).toString();
                this.mis[this.mis.length - 1].start_date = null;
                this.mis[this.mis.length - 1].end_date = null;
                this.mis[this.mis.length - 1].year_price = selectedRow.map((x) => x.effective_first).toString();
                this.mis[this.mis.length - 1].multi_year_price = selectedRow.map((x) => x.effective_multi).toString();
                this.mis[this.mis.length - 1].year_price_per = selectedRow.map((x) => x.effective_first_per).toString();
                this.mis[this.mis.length - 1].multi_year_price_per = selectedRow.map((x) => x.effective_multi_per).toString();
                this.mis[this.mis.length - 1].selectableOption = "";
                this.mis[this.mis.length - 1].disabledYearPrice = false;
                // this.mis[this.mis.length - 1].disabledMultiYearPrice = false;
            } else {
                this.mis.push({
                    checkBox: false,
                    tld_id: getDuplicateTld,
                    type: selectedRow.map((x) => x.type).toString(),
                    period: selectedRow.map((x) => x.period).toString(),
                    start_date: null,
                    end_date: null,
                    year_price: selectedRow.map((x) => x.effective_first).toString(),
                    multi_year_price: selectedRow.map((x) => x.effective_multi).toString(),
                    year_price_per: selectedRow.map((x) => x.effective_first_per).toString(),
                    multi_year_price_per: selectedRow.map((x) => x.effective_multi_per).toString(),
                    selectableOption: "",
                    disabledYearPrice: false,
                    // disabledMultiYearPrice: false,
                    configFromdateTimePicker: {
                        minDate: new Date(this.$moment().subtract(9, 'months')),
                        maxDate: null,
                        wrap: true,
                    },
                    configTodateTimePicker: {
                        minDate: null,
                        wrap: true,
                    },
                });
            }
        },

        minYearPrice() {
            (this.getMinYearPrice = []), (this.getMinMultiYearPrice = []);

            // Get min value for 1st year
            this.promos.forEach((element) => {
                if (element["year_price"].length) {
                    var yearPrice = element["year_price"];
                    this.getMinYearPrice.push(yearPrice);
                }
            });

            if (this.getMinYearPrice.length) {
                var MinYearPrice = Math.min(...this.getMinYearPrice);
                this.mis.forEach((element) => {
                    element.year_price = MinYearPrice;
                });
            } else {
                this.mis.forEach((element) => {
                    element.year_price = "";
                });
            }

            // Get min value for multi year
            this.promos.forEach((element) => {
                if (element["multi_year_price"].length) {
                    var multiYearPrice = element["multi_year_price"];
                    this.getMinMultiYearPrice.push(multiYearPrice);
                }
            });

            if (this.getMinMultiYearPrice.length) {
                var MinMultiYearPrice = Math.min(...this.getMinMultiYearPrice);
                this.mis.forEach((element) => {
                    element.multi_year_price = MinMultiYearPrice;
                });
            } else {
                this.mis.forEach((element) => {
                    element.multi_year_price = "";
                });
            }
        },

        tldForCNICSuggestions() {
            this.cnicpromo.forEach((element) => {
                if (element["tld_id"]) {
                    this.CnicTldValue = element["tld_id"].map((x) => {
                        return {
                            label: x.label,
                            name: x.label,
                            value: x.value,
                        };
                    });
                }
            });
        },

        tldForInternalSuggestions() {
            this.promos.forEach((element) => {
                if (element["tld_id"]) {
                    this.LocalTldValue = element["tld_id"].map((x) => {
                        return {
                            label: x.label,
                            value: x.value,
                        };
                    });
                }
            });
        },

        tldForMISSuggestions() {
            this.mis.forEach((element) => {
                if (element["tld_id"]) {
                    this.MisTldValue = element["tld_id"].map((x) => {
                        return {
                            label: x.label,
                            value: x.value,
                        };
                    });
                }
            });
        },

        customTagCheck() {
            this.formData["existingTagName"] = `${
                this.formData["TagNameData"].includes(
                    this.formData["CustomeTagName"]
                )
                    ? "The Tag name is already exists."
                    : ""
            } `;
        },

        handlePeriod(event) {
            this.promos.forEach((element) => {
                if (element["period"]) {
                    if (!element["period"].length) {
                        element["selectableOption"] = "";
                        element["disabledYearPrice"] = false;
                        element["disabledMultiYearPrice"] = false;
                    } else {
                        if (element["period"].includes("1")) {
                            element["selectableOption"] = "All";
                            element["disabledYearPrice"] = false;
                            element["disabledMultiYearPrice"] = true;
                        } else {
                            element["selectableOption"] = "Other than All";
                            if (
                                element["period"].length == 1 &&
                                !element.type.includes("renew")
                            ) {
                                element["disabledYearPrice"] = true;
                            } else {
                                element["disabledYearPrice"] = false;
                                // TODO: Ask Rushabh if multiyear will be disabled here
                            }
                        }
                    }
                }
            });
        },

        handleMISPeriod(event) {
            this.mis.forEach((element) => {
                if (element["period"]) {
                    if (!element["period"].length) {
                        element["selectableOption"] = "";
                        element["disabledYearPrice"] = false;
                        // element["disabledMultiYearPrice"] = false;
                    } else {
                        if (element["period"].includes("1")) {
                            element["selectableOption"] = "All";
                            element["disabledYearPrice"] = false;
                        // element["disabledMultiYearPrice"] = true;
                        } else {
                            element["selectableOption"] = "Other than All";
                            if (element["period"].length == 1) {
                                element["disabledYearPrice"] = true;
                            } else {
                                element["disabledYearPrice"] = false;
                                // TODO: Ask Rushabh if multiyear will be disabled here
                            }
                        }
                    }
                }
            });
        },

        CNICRelatedData() {
            this.cnicpromo.forEach(el => {
                if (el.selectedCNICIDs !== "") {
                  this.registrarforSuggestions = this.registrarforSuggestions.filter(x => el.selectedCNICIDs.split(", ").indexOf(x.cnic_id) !== -1);
                }
            })
        },

        promoNameFormations() {
            if (this.client_id == "") {
                this.cnicpromo.forEach((element) => {
                    element["promo_name"] = "";
                });
            } else {
                this.PromoNamePartRecommendation = [];
                this.cnicpromo.forEach((element) => {
                    this.promoNameSpan = [];
                    const prefix = process.env.VUE_APP_PREFIX_ENV == "production" ? "" : "staging.";

                    let part1 =
                            this.formData["selectedPromoName"][
                                "selectedGroup"
                            ] !== ""
                                ? prefix +
                                  this.formData["selectedPromoName"][
                                      "selectedGroup"
                                  ]
                                : prefix +
                                  this.formData["selectedPromoName"][
                                      "selectedClient"
                                  ],
                        selectedTld,
                        selectedType,
                        selectedPremium,
                        selectedMonthYear,
                        promoNameArray = [];

                    if (element["tld_id"]) {
                        this.tldValue = element["tld_id"].map((x) => {
                            return {
                                label: x.label,
                                value: x.id,
                            };
                        });

                        const tldString = this.tldValue
                            .map((x) => x.label)
                            .toString()
                            .split(".");

                        const tldStringJoin = tldString.join("-");

                        selectedTld = tldStringJoin;
                    }

                    if (element["type_of_reg"] == "Registration") {
                        selectedType = "Reg";
                    } else if (element["type_of_reg"] == "Renewal") {
                        selectedType = "Ren";
                    } else {
                        selectedType = "";
                    }

                    if (element["premium"].value == 1) {
                        selectedPremium = "Prem";
                    } else {
                        selectedPremium = "";
                    }

                    if (element["start_date"]) {
                        var startDate = this.$moment(element["start_date"]);
                        var monYear =
                            startDate.format("MMM") +
                            "." +
                            startDate.format("YY");
                        selectedMonthYear = monYear;
                    }

                    this.formData["promo_name_new"] = `${
                        part1 != "" && part1 != undefined ? part1 : ""
                    }${
                        selectedTld != "" && selectedTld != undefined
                            ? "." + selectedTld
                            : ""
                    }${
                        selectedType != "" && selectedType != undefined
                            ? "." + selectedType
                            : ""
                    }${
                        selectedPremium != "" && selectedPremium != undefined
                            ? "." + selectedPremium
                            : ""
                    }${
                        selectedMonthYear != "" &&
                        selectedMonthYear != undefined
                            ? "." + selectedMonthYear
                            : ""
                    }`;

                    const envIndex = process.env.VUE_APP_PREFIX_ENV == "production" ? 0 : 1;

                    const index = part1.split(".").length - 1;
                    const name = this.formData["promo_name_new"];
                    const nameArray = name.split(".");
                    const nameString = nameArray.slice(index + 2).join(".");
                    var clientArray;
                    if (
                        (envIndex && index > 1) ||
                        (envIndex == 0 && index >= 1)
                    ) {
                        clientArray = [
                            nameArray.slice(envIndex, index + 1).join("."),
                        ];
                    } else {
                        clientArray =
                            nameArray[envIndex] !== undefined
                                ? nameArray[envIndex].split(",")
                                : [];
                    }
                    const tldArray =
                        nameArray[index + 1] !== undefined
                            ? nameArray[index + 1].split(",")
                            : [];
                    clientArray.forEach((x, index) => {
                        element["selectedCNICIDs"].split(', ').forEach(y => {
                            tldArray.forEach((z) => {
                                if(this.formData['group_id'] && this.formData['group_id'].hasOwnProperty('label')) {
                                    promoNameArray.push({
                                        name: `${prefix}${x}.${z}.${nameString}`,
                                    });
                                } else {
                                    promoNameArray.push({
                                        name: `${prefix}${x}.${y}.${z}.${nameString}`,
                                    });
                                }
                            })
                        });
                    });
                    this.PromoNamePartRecommendation.push(promoNameArray);
                    this.promoNameSpan = [
                        ...this.promoNameSpan,
                        ...promoNameArray.map((x) => x.name),
                    ];
                    element["promo_name"] = this.promoNameSpan.toString();
                });
            }
        },

        openAddTagModal(counter) {
            this.popupCustomTag = true;
            this.tempCustomTag = counter;
        },

        onAddCustomTag() {
            //Loader
            this.$vs.loading({
                container: ".div-with-agreement-modal-loading",
                scale: 0.8,
            });

            this.$axiosSecure
                .post("/custom-tag", {
                    tag_name: this.formData["CustomeTagName"].toLowerCase(),
                    comments: this.formData["CustomeTagComments"],
                })
                .then((response) => {
                    var tempObj = {
                        label: response.data.map((x) => x.tag_name).toString(),
                        value: response.data.map((x) => x.id).toString(),
                    };
                    this.popupCustomTag = false;

                    setTimeout(() => {
                        this.promos[this.tempCustomTag].custom_tag = tempObj;
                        this.formData["CustomeTagName"] = "";
                        this.formData["CustomeTagComments"] = "";
                        this.tempCustomTag = "";
                        // Hide loader
                        this.$vs.loading.close(
                            ".div-with-agreement-modal-loading > .con-vs-loading"
                        );
                        // Confimation notification
                        this.$vs.dialog({
                            color: "success",
                            title: "Thank You",
                            text: "Custom tag has been successfully added.",
                            acceptText: "Close",
                        });
                    }, 100);

                    this.$store.dispatch("setCustomTags");
                })
                .catch((error) => {
                    this.popupCustomTag = false;
                    // Hide loader
                    this.$vs.loading.close(
                        ".div-with-agreement-modal-loading > .con-vs-loading"
                    );
                    setTimeout(() => {
                        //Error msg
                        this.$vs.dialog({
                            color: "danger",
                            title: "Error",
                            text: "Please contact the server admin.",
                            acceptText: "Close",
                        });
                    }, 100);
                });
        },

        autoWidthForAgtNames() {
            var number = this.agtFileData.length;
            var percentage = 252 / number;
            var somaPercentual = new Array();
            for (var i = 0; i < number; i++) {
                somaPercentual.push(percentage);
            }

            var agtnames = document.querySelectorAll(".filename-wrap");

            agtnames.forEach((name, index) => {
                name.style.width = somaPercentual[index] + "px";
            });
        },

        verifyPromo() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    // If Agreement isn't selected, throw an error (except when only MIS is being added) and when promos are being added for groups
                    //     // TODO: Hotfix to bypass agreements for promo creation. Remove once done.
                    // if (
                    //     (this.agtFileData && this.agtFileData.length) ||
                    //     (!this.flags["enabledCNIC"] &&
                    //         !this.flags["enabledInternal"] &&
                    //         this.flags["enabledMIS"]) ||
                    //     (this.formData["group_id"] &&
                    //         this.formData["group_id"].hasOwnProperty("label"))
                    // ) {
                        this.formData["verifyPromo"] =
                            !this.formData["verifyPromo"];
                    // } else {
                    //     this.$vs.notify({
                    //         time: 4000,
                    //         color: "danger",
                    //         title: "Required",
                    //         text: "Please select atleast one agreement to proceed",
                    //     });
                    // }
                } else {
                    this.formData["agtsError"] =
                        "Please check the above errors";
                }
            });
        },

        onSubmit() {
            this.formData["verifyPromo"] = false;
            var cnicPriceObject = {
                amtNum: [],
                perNum: [],
            };

            this.cnicpromo.forEach((x) => {
                if (x.premium.value == 0) {
                    cnicPriceObject["amtNum"].push(
                        (Math.round(x.effective_price_amt * 100) / 100).toFixed(
                            2
                        )
                    );
                    cnicPriceObject["perNum"].push(0);
                } else {
                    cnicPriceObject["amtNum"].push(0);
                    cnicPriceObject["perNum"].push(
                        (Math.round(x.effective_price_per * 100) / 100).toFixed(
                            2
                        )
                    );
                }
            });

            var priceObject = {
                amtNum: [],
                perNum: [],
                amtMulti: [],
                perMulti: [],
                retailPrice: [],
            };

            this.promos.forEach((x) => {
                if (!x.type.includes("premium")) {
                    priceObject["amtNum"].push(
                        (Math.round(x.year_price * 100) / 100).toFixed(2)
                    );
                    priceObject["amtMulti"].push(
                        (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
                    );
                    priceObject["retailPrice"].push(
                        (Math.round(x.retail_price * 100) / 100).toFixed(2)
                    );
                    priceObject["perNum"].push(0);
                    priceObject["perMulti"].push(0);
                } else {
                    priceObject["amtNum"].push(0);
                    priceObject["amtMulti"].push(0);
                    priceObject["retailPrice"].push(0);
                    priceObject["perNum"].push(
                        (Math.round(x.year_price_per * 100) / 100).toFixed(2)
                    );
                    priceObject["perMulti"].push(
                        (
                            Math.round(x.multi_year_price_per * 100) / 100
                        ).toFixed(2)
                    );
                }
            });

            var misPriceObject = {
                amtNum: [],
                perNum: [],
                amtMulti: [],
                perMulti: [],
            };

            this.mis.forEach((x) => {
                if (!x.type.includes("premium")) {
                    misPriceObject["amtNum"].push(
                        (Math.round(x.year_price * 100) / 100).toFixed(2)
                    );
                    misPriceObject["amtMulti"].push(
                        (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
                    );
                    misPriceObject["perNum"].push(0);
                    misPriceObject["perMulti"].push(0);
                } else {
                    misPriceObject["amtNum"].push(0);
                    misPriceObject["amtMulti"].push(0);
                    misPriceObject["perNum"].push(
                        (Math.round(x.year_price_per * 100) / 100).toFixed(2)
                    );
                    misPriceObject["perMulti"].push(
                        (
                            Math.round(x.multi_year_price_per * 100) / 100
                        ).toFixed(2)
                    );
                }
            });

            if (this.agtFileData.length) {
                var getGeneralAgreement = this.agtFileData.map((x) => x.value);
            } else {
                var getGeneralAgreement = null;
            }

            if (this.promos.length) {
                var getLocalAgreement = [];
                for (var i = 0; i < this.promos.length; i++) {
                    if (this.promos[i].internalAgtFileData.length) {
                        getLocalAgreement.push(
                            this.promos[i].internalAgtFileData.map(
                                (x) => x.value
                            )
                        );
                    } else {
                        getLocalAgreement.push(null);
                    }
                }
            }

            var getReseller = {},
                cnicPromoData = {},
                localPromoData = {},
                misData = {};

            if (this.flags["enabledCNIC"] == true) {
                cnicPromoData = this.cnicpromo.map((x, index) => {
                    return {
                        new_registrar_id: (this.formData['group_id'] && this.formData['group_id'].hasOwnProperty('label')) ? null : (x.selectCNICIDs["registrars"].length > 1 ? x.selectCNICIDs["registrars"].filter(x => x.checkBox).map(y => y.new_registrar_id) : x.selectCNICIDs["registrars"].map(y => y.new_registrar_id)),
                        tld_id: x.tld_id.map((y) => {
                            return y.value;
                        }),
                        effective_price_amt: cnicPriceObject["amtNum"][index],
                        effective_price_per: cnicPriceObject["perNum"][index],
                        premium: x.premium.value,
                        type_of_reg: x.type_of_reg,
                        start_date: x.start_date,
                        end_date: x.end_date,
                        start_time: x.start_time,
                        end_time: x.end_time,
                        promo_name: this.PromoNamePartRecommendation[index].map(
                            (x) => x.name
                        ),
                    };
                });
            } else {
                cnicPromoData = [];
            }

            localPromoData = this.promos.map((x, index) => {
                return {
                    tld_id: x.tld_id.map((y) => {
                        return y.value;
                    }),
                    period: x.period,
                    type: x.type,
                    list_based: x.list_based.toLowerCase(),
                    effective_first: priceObject["amtNum"][index],
                    effective_multi: priceObject["amtMulti"][index],
                    effective_first_per: priceObject["perNum"][index],
                    effective_multi_per: priceObject["perMulti"][index],
                    retail_price: priceObject["retailPrice"][index],
                    retail_currency_id: x.retail_currency.value,
                    promo_tag_id: x.promo_tag.value,
                    custom_tag_id: x.custom_tag.value,
                    geo_id: x.geo.value,
                    start_date: x.start_date,
                    end_date: x.end_date,
                    comments: x.comments,
                    local_agreements: getLocalAgreement[index],
                    existing_local_agreement: null,
                };
            });

            misData = this.mis.map((x, index) => {
                return {
                    tld_id: x.tld_id.map((y) => {
                        return y.value;
                    }),
                    period: x.period,
                    type: x.type,
                    effective_first: misPriceObject["amtNum"][index],
                    effective_multi: misPriceObject["amtMulti"][index],
                    effective_first_per: misPriceObject["perNum"][index],
                    effective_multi_per: misPriceObject["perMulti"][index],
                    start_date: x.start_date,
                    end_date: x.end_date,
                };
            });

            var formatedInternal = this.flags["enabledInternal"]
                ? localPromoData
                : [];
            var formatedMIS = this.flags["enabledMIS"] ? misData : [];
            this.$validator.validateAll().then((result) => {
                if (result) {
                    //Loader
                    this.openLoadingInDiv();
                    this.flags["isFormSubmitted"] = true;
                    this.$axiosSecure
                        .post("/create-all", {
                            currency_id:
                                this.formData["currency_type"]["value"],
                            user_id: this.user_id,
                            group_by: this.formData["group_id"].value,
                            payment_mode: this.formData["payment_mode"] ? this.formData["payment_mode"].toLowerCase() : this.formData["payment_mode"],
                            list_frequency: this.formData["list_frequency"] ? this.formData["list_frequency"].toLowerCase() : this.formData["list_frequency"],
                            // payment_mode: this.formData["payment_mode"].toLowerCase(),
                            // list_frequency: this.formData["list_frequency"].toLowerCase(),
                            status: this.formData["status"],
                            comments: this.formData["common_comments"],
                            new_reseller_id: this.reseller_id ? parseInt(this.reseller_id) : null,
                            unique_registrar_id: this.registrar_id ? parseInt(this.registrar_id) : null,
                            general_agreements: getGeneralAgreement,
                            cnic: cnicPromoData,
                            localpromo: formatedInternal,
                            mis: formatedMIS,
                        })
                        .then((response) => {
                            setTimeout(() => {
                                this.flags["isFormSubmitted"] = false;
                                this.resetFields();
                                this.hideLoadingInDiv();
                                // Confimation notification
                                this.$vs.dialog({
                                    color: "success",
                                    title: "Thank You",
                                    text: "Promo Request has been successfully created.",
                                    acceptText: "View List",
                                    accept: () => {
                                        this.$router.push({
                                            path: "/promos/requests",
                                        });
                                    },
                                });
                            }, 100);
                        })
                        .catch((error) => {
                            setTimeout(() => {
                                // Hide loader
                                this.hideLoadingInDiv();
                                this.flags["isFormSubmitted"] = false;
                                // if (
                                //     error.response.data.resoneOfError ==
                                //         "CNIC duplicate" ||
                                //     error.response.data.resoneOfError ==
                                //         "timeerror" ||
                                //     error.response.data.resoneOfError ==
                                //         "mis duplicate" ||
                                //     error.response.data.resoneOfError ==
                                //         "Date OverLapping"
                                // ) {
                                //     this.errorMessage =
                                //         error.response.data.message;
                                // } else {
                                //     this.errorMessage =
                                //         "Please contact the server admin.";
                                // }

                                this.errorMessage =
                                    (error.response && error.response.data && error.response.data.message) ||
                                    "Please contact the server admin.";

                                //Error msg
                                this.$vs.dialog({
                                    color: "danger",
                                    title: "Error",
                                    text: this.errorMessage,
                                    acceptText: "Close",
                                    accept: () => {},
                                });
                            }, 100);
                        });
                } else {
                    // form has errors
                    // console.log("form has errors");
                }
            });
        },

        resetGroup() {
            if (
                this.formData["group_id"] &&
                this.formData["group_id"].hasOwnProperty("label")
            ) {
                this.formData["selectedPromoName"]["selectedGroup"] = "";
                this.flags["enabledEntity"] = true;
                this.formData["group_id"] = [];
                this.disableOrEnableCNIC(true);
                this.disableOrEnableInternalAndMis(true);
            }
        },

        resetFields() {
            (this.client_id = null),
                (this.reseller_id = null),
                (this.registrar_id = null),
                (this.registrar_name = null),
                (this.CnicTldValue = []),
                (this.LocalTldValue = []),
                (this.registrarforSuggestions = []),
                (this.resellerForSuggestions = []),
                (this.groupClientName = []),
                (this.enabledCNICText = "Enabled"),
                (this.enabledInternalText = "Enabled"),
                (this.enabledMISText = "Enabled"),
                (this.agtFileData = []),
                (this.formData["currency_type"] = {
                    label: "USD  -  $",
                    value: 12,
                    sign: "$",
                });
            this.formData["payment_mode"] = "";
            this.formData["list_frequency"] = "";
            this.formData["list_based"] = "Yes";
            (this.formData["selectedPromoName"]["selectedGroup"] = ""),
                (this.formData["selectedPromoName"]["selectedTLD"] = ""),
                (this.formData["selectedPromoName"]["selectedClient"] = ""),
                (this.formData["selectedPromoName"]["selectedType"] = ""),
                (this.formData["selectedPromoName"]["selectedPrem"] = ""),
                (this.formData["selectedPromoName"]["selectedMonthYear"] = ""),
                (this.formData["promo_name"] = ""),
                (this.formData["verifyPromo"] = false),
                this.disableOrEnableInternalAndMis(true),
                this.disableOrEnableCNIC(true),
                (this.formData["common_comments"] = ""),
                (this.formData["disaplayTimezone"] = "(UTC)"),
                this.cnicpromo.forEach((element) => {
                    (element.checkBox = false),
                        (element.promo_name = ""),
                        (element.tld_id = []),
                        (element.effective_price_amt = ""),
                        (element.effective_price_per = ""),
                        (element.price_type = [{ label: "$", value: "$" }]),
                        (element.premium = { label: "No", value: 0 }),
                        (element.type_of_reg = ""),
                        (element.start_date = null),
                        (element.end_date = null),
                        (element.start_time = "00:00:00"),
                        (element.end_time = "23:59:59"),
                        (element.configFromdateTimePicker = {
                            minDate: new Date(),
                            maxDate: null,
                        }),
                        (element.configTodateTimePicker = {
                            minDate: null,
                        }),
                        element.selectedCNICIDs = "",
                        element.selectCNICIDs = {},
                        element.tempSelectCNICIDs = {};
                });
            this.promos.forEach((element) => {
                (element.checkbox = false),
                    (element.type = []),
                    (element.tld_id = []),
                    (element.period = []),
                    (element.currencySign = "$"),
                    (element.start_date = null),
                    (element.end_date = null),
                    (element.retail_price = ""),
                    (element.retail_currency = {
                        label: "USD  -  $",
                        value: 12,
                        sign: "$",
                    }),
                    (element.year_price = ""),
                    (element.year_price_per = ""),
                    (element.multi_year_price = ""),
                    (element.multi_year_price_per = ""),
                    (element.promo_tag = []),
                    (element.internalAgtFileData = []),
                    (element.custom_tag = {
                        label: "NA",
                        value: null,
                    }),
                    (element.geo = {
                        label: "NA",
                        value: null,
                    }),
                    (element.uploadedLocalFile = ""),
                    (element.selectableOption = ""),
                    (element.disabledYearPrice = false),
                    (element.disabledMultiYearPrice = false),
                    (element.comments = "");
            });
            this.mis.forEach((element) => {
                (element.tld_id = []),
                    (element.type = []),
                    (element.period = []),
                    (element.start_date = null),
                    (element.end_date = null),
                    (element.year_price = ""),
                    (element.year_price_per = ""),
                    (element.multi_year_price = ""),
                    (element.multi_year_price_per = ""),
                    (element.disableMIS = true),
                    (element.MISEnableText = "Enabled"),
                    (element.disabledYearPrice = false);
                    // (element.disabledMultiYearPrice = false);
            });

            //Remove all the repetative form data and keep only one
            this.resetGroup();
            this.cnicpromo.splice(1);
            this.promos.splice(1);
            this.mis.splice(1);
            this.$validator.reset();
        },

        duplicateMISSuggestion(value) {
            var selectedMISData = value;

            var getDuplicateTld = {
                label: selectedMISData.tld.tld_name,
                value: selectedMISData.tld.id,
                name: selectedMISData.tld.tld_name,
            };

            if (
                this.mis[this.mis.length - 1].tld_id == "" ||
                this.mis[this.mis.length - 1].type == "" ||
                this.mis[this.mis.length - 1].period == ""
            ) {
                this.mis[this.mis.length - 1].tld_id = [getDuplicateTld];
                this.mis[this.mis.length - 1].type = selectedMISData.type;
                this.mis[this.mis.length - 1].period = selectedMISData.period;
                this.mis[this.mis.length - 1].year_price_per =
                    selectedMISData.effective_first_per;
                (this.mis[this.mis.length - 1].multi_year_price_per =
                    selectedMISData.effective_multi_per),
                    (this.mis[this.mis.length - 1].year_price =
                        selectedMISData.effective_first);
                this.mis[this.mis.length - 1].multi_year_price =
                    selectedMISData.effective_multi;
                this.mis[this.mis.length - 1].MISEnableText = "Enabled";
                this.mis[this.mis.length - 1].disableMIS = true;
                this.mis[this.mis.length - 1].selectableOption = "";
                this.mis[this.mis.length - 1].disabledYearPrice = false;
                // this.mis[this.mis.length - 1].disabledMultiYearPrice = false;
            } else {
                this.mis.push({
                    tld_id: [getDuplicateTld],
                    type: selectedMISData.type,
                    period: selectedMISData.period,
                    year_price: selectedMISData.effective_first,
                    multi_year_price: selectedMISData.effective_multi,
                    year_price_per: selectedMISData.effective_first_per,
                    multi_year_price_per: selectedMISData.effective_multi_per,
                    MISEnableText: "Enabled",
                    disableMIS: true,
                    selectableOption: "",
                    disabledYearPrice: false,
                    // disabledMultiYearPrice: false,
                    configFromdateTimePicker: {
                        minDate: new Date(this.$moment().subtract(9, 'months')),
                        maxDate: null,
                        wrap: true,
                    },
                    configTodateTimePicker: {
                        minDate: null,
                        wrap: true,
                    },
                });
            }
        },
        disableOrEnableInternalAndMis(flag) {
            this.flags["enabledInternal"] = flag;
            this.flags["enabledMIS"] = flag;
            this.enabledInternalText = flag ? "Enabled" : "Disabled";
            this.enabledMISText = flag ? "Enabled" : "Disabled";
            this.formData["internalRequired"] = flag ? "required" : "";
            this.formData["internalData"] = flag;
            this.formData["misRequired"] = flag ? "required" : "";
            this.formData["MISData"] = flag;
        },
        disableOrEnableCNIC(flag) {
            if(this.disableCNICFlag) {
                this.flags["enabledCNIC"] = false;
                this.enabledCNICText = "Disabled";
                this.formData["CNICRequired"] = "";
                this.formData["CNICData"] = false;
            } else {
                this.flags["enabledCNIC"] = flag;
                this.enabledCNICText = flag ? "Enabled" : "Disabled";
                this.formData["CNICRequired"] = flag ? "required" : "";
                this.formData["CNICData"] = flag;
            }
        },

        filterLocalPromoAgreements(agreementsData) {
            this.selectedGeneralAgreements = agreementsData;
        },
        openSelectCNICIDsPopup(index) {
            let client_id_split = this.client_id.split("-"),
                reg_id;

            this.cnicPromoCounterForCNICID = index;

            if (client_id_split[0] == "CNIC") {
                reg_id = client_id_split[1];
            } else {
                reg_id = client_id_split[2];
            }

            let registrars = this.$store.getters.getRegistrars;
            let registrar = registrars.find((x) => x.id == reg_id);

            this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["tlds"] = this.cnicpromo[this.cnicPromoCounterForCNICID]["tld_id"];
            this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["unique_registrar"] = registrar["id"];


            if(this.cnicpromo[this.cnicPromoCounterForCNICID]["selectedCNICIDs"] && this.cnicpromo[this.cnicPromoCounterForCNICID]["selectedCNICIDs"].length && registrar.new_registrar.length > 1) {
                this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["registrars"] = JSON.parse(JSON.stringify(this.cnicpromo[this.cnicPromoCounterForCNICID]["selectCNICIDs"]["registrars"]))
            } else {
                this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["registrars"] = registrar.new_registrar.map(
                    (x) => {
                        return {
                            checkBox: false,
                            name: registrar["name"],
                            new_registrar_id: x["id"],
                            cnic_id: x["cnic_id"],
                        };
                    }
                );
            }

            if (registrar.new_registrar.length > 1) {
                this.popupSelectCNICIDs = true;
            } else {
                this.cnicpromo[this.cnicPromoCounterForCNICID]["selectedCNICIDs"] = this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["registrars"].map((x) => x.cnic_id).join(", ");
                this.cnicpromo[this.cnicPromoCounterForCNICID]["selectCNICIDs"] = JSON.parse(JSON.stringify(this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]));
            }
        },
        validateCNICIDTLDCombination() {
            this.cnicpromo[this.cnicPromoCounterForCNICID]["selectCNICIDs"] = JSON.parse(JSON.stringify(this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]));
            let copySelectCNICIDs = JSON.parse(JSON.stringify(this.cnicpromo[this.cnicPromoCounterForCNICID]["selectCNICIDs"]));

            let payload = {
                tlds: copySelectCNICIDs.tlds.map((x) => {
                    return {
                        name: x["label"],
                        id: x["value"],
                    };
                }),
                registrars: copySelectCNICIDs.registrars
                .filter((x) => x.checkBox === true)
                .map((x) => {
                    x.cnic_id = x.cnic_id;
                    delete x.checkBox;
                    return x;
                }),
                unique_registrar: this.cnicpromo[this.cnicPromoCounterForCNICID]["selectCNICIDs"]["unique_registrar"]
            }

        
            this.$axiosSecure
                .post(
                    "/cnic-promos/registrar-tld-check",
                    payload
                )
                .then((response) => {
                    // console.log(copySelectCNICIDs);
                    this.popupSelectCNICIDs = false;
                    this.cnicpromo[this.cnicPromoCounterForCNICID]["selectedCNICIDs"] = copySelectCNICIDs["registrars"]
                        .filter((x) => x.checkBox !== false)
                        .map((x) => x.cnic_id)
                        .join(", ");
                })
                .catch((error) => {
                    this.customPromptError = error.response.data.data;
                    this.customPrompt["classList"] = "danger-prompt";
                    this.customPrompt["color"] = "danger";
                    this.customPrompt["activePrompt"] = true;
                });
        },
        selectAllCNICIDs() {
            this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["registrars"].forEach((x, index) => {
                this.$set(this.cnicpromo[this.cnicPromoCounterForCNICID]["tempSelectCNICIDs"]["registrars"][index], 'checkBox', true);
            });
        }
    },
    mounted() {
        let self = this;

        this.$root.$on("copyCnicPromo", (selectedRow) => {
            this.formatCopiedCnicData(selectedRow);
        });

        this.$root.$on("copyMIS", (selectedRow) => {
            this.formatCopiedMIS(selectedRow);
        });

        this.$root.$on("copyPromo", (selectedRow) => {
            this.formatCopiedPromo(selectedRow);
        });

        this.$root.$on("selectedAgts", (id) => {
            if (this.flags.internalAgmt == true) {
                for (var i = 0; i < this.promoCounter.length; i++) {
                    var promoCounterValue = this.promoCounter[i];
                    this.promos[promoCounterValue].internalAgtFileData = id;
                }
            } else {
                this.agtFileData = id;
            }
        });

        if(this.disableCNICFlag) {
            this.disableOrEnableCNIC(false);
        }
    },
    destroyed() {
        this.popupSelectCNICIDs = false;
    },
};
</script>

<style lang="scss">
.enabledBtn {
    background-color: rgba(var(--vs-primary), 1) !important;
    color: white;
}

.disabledBtn {
    background-color: white !important;
}

.enabledBtn,
.disabledBtn {
    position: absolute;
    right: 16rem;
}

.openselectCNICIDPopup-footer {
    position: fixed;

}

.openselectCNICIDPopup-btn {
    background: #0142f7;
    color: #fff;
    font-family: "Work Sans", sans-serif;
    font-weight: 500;
    letter-spacing: -0.65px;
    position: absolute;
    // top: calc(70% + 10px);
    // top: 550px;
    width: 100%;
    // left: 0;
    text-align: center;
    padding: 7px 10px;
    border-radius: 5px;
    cursor: pointer;
}

.tld-wrap {
    position: relative;
    margin: 0px 0px;
    // padding: 10px 0px;
    display: inline-flex;
    // height: 30px;
}

.tld-wrap.isActive {
    background: #d5d5d5;
}

.tld-wrap:before {
    content: "";
    background: #d1d1d1;
    height: 20px;
    width: 1px;
    position: absolute;
    top: 7px;
    right: 0;
}
.tld-wrap .vue-treeselect {
    position: absolute;
    right: 0;
    // width: 200px;
    // top: 100%;
}

.tld-wrap {
    .vue-treeselect {
        .vue-treeselect__control {
            border: 0px !important;
        }
    }
}

.cnic_id {
    border-left: 1px solid #e8e8e8;
}

table,
th,
td {
    border-collapse: collapse;
}

.cell-table {
    width: 100%;
    border: 1px solid #e8e8e8;
    border-collapse: collapse;
    table-layout: fixed;

    td {
        padding: 0.5rem;
    }
}
</style>